var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _g, _path838, _path839, _g2, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourZeroFour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 438,
    viewBox: "0 0 586 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586 384.173H0V384.466H586V384.173Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.283 403.03H488.467V403.323H527.283V403.03Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.191 406.218H378.006V406.511H388.191V406.218Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M487.293 392.154H464.803V392.447H487.293V392.154Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.101 394.123H61.4824V394.416H112.101V394.123Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.964 394.123H122.545V394.416H129.964V394.123Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.875 399.069H154.082V399.362H263.875V399.069Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277.763 331.902H51.4617C49.6888 331.898 47.9897 331.192 46.7372 329.937C45.4847 328.683 44.7812 326.982 44.7813 325.209V7.09348C44.7967 5.33082 45.5069 3.64543 46.7578 2.40339C48.0086 1.16135 49.6989 0.46298 51.4617 0.459961H277.763C279.538 0.459961 281.24 1.16502 282.495 2.42004C283.75 3.67505 284.455 5.37722 284.455 7.15208V325.209C284.455 326.984 283.75 328.686 282.495 329.941C281.24 331.196 279.538 331.902 277.763 331.902ZM51.4617 0.694362C49.7665 0.697466 48.1419 1.37303 46.9444 2.57276C45.7468 3.77249 45.0742 5.39836 45.0743 7.09348V325.209C45.0742 326.905 45.7468 328.53 46.9444 329.73C48.1419 330.93 49.7665 331.605 51.4617 331.609H277.763C279.459 331.605 281.085 330.93 282.285 329.731C283.484 328.531 284.159 326.906 284.162 325.209V7.09348C284.159 5.39728 283.484 3.77144 282.285 2.57204C281.085 1.37264 279.459 0.69746 277.763 0.694362H51.4617Z",
    fill: "#D2D2D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M531.279 331.902H304.966C303.192 331.898 301.491 331.192 300.237 329.938C298.983 328.684 298.277 326.983 298.273 325.209V7.09348C298.292 5.32975 299.005 3.64437 300.257 2.40266C301.51 1.16094 303.202 0.462948 304.966 0.459961H531.279C533.039 0.466061 534.727 1.1658 535.975 2.40751C537.223 3.64921 537.932 5.33285 537.947 7.09348V325.209C537.947 326.98 537.246 328.679 535.996 329.933C534.746 331.188 533.05 331.895 531.279 331.902ZM304.966 0.694362C303.269 0.69746 301.644 1.37264 300.444 2.57204C299.245 3.77144 298.57 5.39728 298.566 7.09348V325.209C298.57 326.906 299.245 328.531 300.444 329.731C301.644 330.93 303.269 331.605 304.966 331.609H531.279C532.975 331.605 534.601 330.93 535.8 329.731C537 328.531 537.675 326.906 537.678 325.209V7.09348C537.675 5.39728 537 3.77144 535.8 2.57204C534.601 1.37264 532.975 0.69746 531.279 0.694362H304.966Z",
    fill: "#D2D2D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M391.822 116.113H375.297V84.3517L390.533 86.0628L390.861 86.4847L391.178 86.1449L418.977 89.2624L419.235 89.5788L419.481 89.3093L475.433 95.5912V347.208H490.926V73.8389H372.191V116.113H356.709V124.317H391.869L391.822 116.113ZM475.468 92.4737L466.912 91.5126L475.468 79.7926V92.4737ZM473.757 76.9329L464.709 89.2741L454.29 76.9329H473.757ZM462.037 90.9969L442.816 88.8405L452.133 79.2652L462.037 90.9969ZM450.047 76.9329L440.214 87.0473L431.037 76.9329H450.047ZM437.155 88.1724L422.212 86.4965L428.951 79.2183L437.155 88.1724ZM426.935 76.9329L419.458 84.8439L413.188 76.9329H426.935ZM416.387 85.8401L406.542 84.7267L411.23 79.3473L416.387 85.8401ZM409.25 76.9329L404.198 82.6992L399.604 76.9329H409.25ZM401.397 84.1525L393.897 83.3086L397.541 79.3121L401.397 84.1525ZM395.537 76.9329L391.166 81.7147L387.369 76.9329H395.537ZM387.955 82.6406L382.763 82.0663L385.294 79.3121L387.955 82.6406ZM383.267 76.9329L380.489 79.9333L378.286 76.9329H383.267ZM375.391 78.2339L377.805 81.5037L375.391 81.2342V78.2339Z",
    fill: "#F0F0F0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M407.317 118.175H403.168V327.823H456.869V111.976H452.744V131.595H432.093V121.27H428.952V131.595H407.27L407.317 118.175ZM432.093 136.763H452.755V148.132H432.093V136.763ZM407.317 136.763H428.952V148.132H407.27L407.317 136.763Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.343 132.896V53.2002H90.2441V374H106.113V75.5854L163.67 69.1394L163.928 69.409L164.186 69.0808L192.782 65.8695L193.099 66.2211L193.439 65.7992L209.155 64.0295V132.896H192.208V141.393H228.317V132.896H212.343ZM130.092 58.7672L139.667 68.6237L119.896 70.8388L130.092 58.7672ZM117.2 69.0925L107.894 56.3998H127.924L117.2 69.0925ZM132.225 56.3998H151.774L142.34 66.7954L132.225 56.3998ZM209.167 57.7358V60.8299L206.682 61.1112L209.167 57.7358ZM203.916 59.4938L201.068 56.3998H206.19L203.916 59.4938ZM196.884 56.3998L192.97 61.3222L188.481 56.3998H196.884ZM184.285 56.3998L179.597 62.3301L174.417 56.3998H184.285ZM170.221 56.3998L163.775 64.5334L156.146 56.3998H170.221ZM106.16 59.3884L114.973 71.4014L106.16 72.3858V59.3884ZM145.633 67.9557L153.978 58.7555L161.01 66.2328L145.633 67.9557ZM172.284 58.8844L177.125 64.4162L166.998 65.5882L172.284 58.8844ZM182.41 63.8302L186.383 58.8492L190.134 62.963L182.41 63.8302ZM198.982 58.8492L201.596 61.6738L196.252 62.2715L198.982 58.8492Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.222 148.812H153.954V138.193H150.766V148.812H129.483V128.63H125.24V350.63H180.488V134.982H176.234L176.222 148.812ZM150.731 165.806H129.483V154.086H150.731V165.806ZM176.222 165.806H153.954V154.086H176.222V165.806Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M508.66 383.563V329.217H504.018V303.316H497.221V213.283H487.4V201.668L466.433 191.894V180.174H463.526V213.283H459.459V303.316H455.392V255.979H444.364V231.578H441.281V303.316H432.902V276.02H427.381V269.047H414.595V245.232H407.61V228.39H398.996V203.848H395.925V228.39H387.334V245.232H380.326V269.047H367.551V276.02H362.031V303.316H355.491V269.047H342.704V195.281H338.638V187.147H311.342V195.281H305.529V248.713H282.3V253.94H273.592V258.007H282.3V278.927H257.899V209.216H252.671V194.402H241.35V141.838H238.15V194.402H230.017V209.216H182.34V204.341H179.445V237.45H175.378V238.036H172.929V271.145H168.862V280.146H160.271V255.745H157.189V313.841H153.766V289.44H150.684V327.483H148.809V300.187H143.289V293.213H130.514V269.398H123.517V252.557H114.914V228.015H111.844V252.557H103.241V269.398H96.2445V293.213H83.458V300.187H77.9379V326.908H76.9534V327.483H74.2227V383.563H508.66Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 212.475H208.943V215.768H212.237V212.475Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 217.995H208.943V221.288H212.237V217.995Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 240.063H208.943V243.357H212.237V240.063Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 245.584H208.943V248.877H212.237V245.584Z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 251.104H208.943V254.397H212.237V251.104Z",
    fill: "#F5F5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 267.652H208.943V270.946H212.237V267.652Z",
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.237 273.173H208.943V276.466H212.237V273.173Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 234.544H214.172V237.837H217.465V234.544Z",
    fill: "#F5F5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 240.063H214.172V243.357H217.465V240.063Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 245.584H214.172V248.877H217.465V245.584Z",
    fill: "#F5F5F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 251.104H214.172V254.397H217.465V251.104Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 256.624H214.172V259.917H217.465V256.624Z",
    fill: "#F5F5F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 267.652H214.172V270.946H217.465V267.652Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.465 273.173H214.172V276.466H217.465V273.173Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 212.475H219.398V215.768H222.692V212.475Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 217.995H219.398V221.288H222.692V217.995Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 223.515H219.398V226.808H222.692V223.515Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 229.035H219.398V232.328H222.692V229.035Z",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 234.544H219.398V237.837H222.692V234.544Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 240.063H219.398V243.357H222.692V240.063Z",
    fill: "#F5F5F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 245.584H219.398V248.877H222.692V245.584Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 251.104H219.398V254.397H222.692V251.104Z",
    fill: "#F5F5F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 256.624H219.398V259.917H222.692V256.624Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 262.145H219.398V265.438H222.692V262.145Z",
    fill: "#F5F5F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M222.692 273.173H219.398V276.466H222.692V273.173Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 212.475H224.625V215.768H227.918V212.475Z",
    fill: "#F5F5F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 217.995H224.625V221.288H227.918V217.995Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 223.515H224.625V226.808H227.918V223.515Z",
    fill: "#F5F5F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 229.035H224.625V232.328H227.918V229.035Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 234.544H224.625V237.837H227.918V234.544Z",
    fill: "#F5F5F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 240.063H224.625V243.357H227.918V240.063Z",
    fill: "#F5F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 245.584H224.625V248.877H227.918V245.584Z",
    fill: "#F5F5F5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M227.918 295.253H224.625V298.546H227.918V295.253Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 212.475H229.854V215.768H233.147V212.475Z",
    fill: "#F5F5F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 217.995H229.854V221.288H233.147V217.995Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 223.515H229.854V226.808H233.147V223.515Z",
    fill: "#F5F5F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 229.035H229.854V232.328H233.147V229.035Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 234.544H229.854V237.837H233.147V234.544Z",
    fill: "#F5F5F5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 240.063H229.854V243.357H233.147V240.063Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 245.584H229.854V248.877H233.147V245.584Z",
    fill: "#F5F5F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 251.104H229.854V254.397H233.147V251.104Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 284.213H229.854V287.506H233.147V284.213Z",
    fill: "#F5F5F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 289.733H229.854V293.027H233.147V289.733Z",
    fill: "#F5F5F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 295.253H229.854V298.546H233.147V295.253Z",
    fill: "#F5F5F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 300.762H229.854V304.055H233.147V300.762Z",
    fill: "#F5F5F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 322.842H229.854V326.135H233.147V322.842Z",
    fill: "#F5F5F5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 212.475H235.08V215.768H238.373V212.475Z",
    fill: "#F5F5F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 217.995H235.08V221.288H238.373V217.995Z",
    fill: "#F5F5F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 223.515H235.08V226.808H238.373V223.515Z",
    fill: "#F5F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 229.035H235.08V232.328H238.373V229.035Z",
    fill: "#F5F5F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 234.544H235.08V237.837H238.373V234.544Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 240.063H235.08V243.357H238.373V240.063Z",
    fill: "#F5F5F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 245.584H235.08V248.877H238.373V245.584Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 251.104H235.08V254.397H238.373V251.104Z",
    fill: "#F5F5F5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 256.624H235.08V259.917H238.373V256.624Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 262.145H235.08V265.438H238.373V262.145Z",
    fill: "#F5F5F5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 278.692H235.08V281.986H238.373V278.692Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 284.213H235.08V287.506H238.373V284.213Z",
    fill: "#F5F5F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 289.733H235.08V293.027H238.373V289.733Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 295.253H235.08V298.546H238.373V295.253Z",
    fill: "#F5F5F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 300.762H235.08V304.055H238.373V300.762Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M238.373 322.842H235.08V326.135H238.373V322.842Z",
    fill: "#F5F5F5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 212.475H240.318V215.768H243.612V212.475Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 217.995H240.318V221.288H243.612V217.995Z",
    fill: "#F5F5F5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 223.515H240.318V226.808H243.612V223.515Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 229.035H240.318V232.328H243.612V229.035Z",
    fill: "#F5F5F5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 234.544H240.318V237.837H243.612V234.544Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 240.063H240.318V243.357H243.612V240.063Z",
    fill: "#F5F5F5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 245.584H240.318V248.877H243.612V245.584Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 251.104H240.318V254.397H243.612V251.104Z",
    fill: "#F5F5F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 256.624H240.318V259.917H243.612V256.624Z",
    fill: "#F5F5F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 262.145H240.318V265.438H243.612V262.145Z",
    fill: "#F5F5F5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 267.652H240.318V270.946H243.612V267.652Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 273.173H240.318V276.466H243.612V273.173Z",
    fill: "#F5F5F5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 278.692H240.318V281.986H243.612V278.692Z",
    fill: "#F5F5F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 284.213H240.318V287.506H243.612V284.213Z",
    fill: "#F5F5F5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 289.733H240.318V293.027H243.612V289.733Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 295.253H240.318V298.546H243.612V295.253Z",
    fill: "#F5F5F5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 300.762H240.318V304.055H243.612V300.762Z",
    fill: "#F5F5F5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M243.612 306.281H240.318V309.575H243.612V306.281Z",
    fill: "#F5F5F5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 212.475H245.545V215.768H248.838V212.475Z",
    fill: "#F5F5F5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 217.995H245.545V221.288H248.838V217.995Z",
    fill: "#F5F5F5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 223.515H245.545V226.808H248.838V223.515Z",
    fill: "#F5F5F5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 229.035H245.545V232.328H248.838V229.035Z",
    fill: "#F5F5F5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 234.544H245.545V237.837H248.838V234.544Z",
    fill: "#F5F5F5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 240.063H245.545V243.357H248.838V240.063Z",
    fill: "#F5F5F5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 245.584H245.545V248.877H248.838V245.584Z",
    fill: "#F5F5F5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 251.104H245.545V254.397H248.838V251.104Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 256.624H245.545V259.917H248.838V256.624Z",
    fill: "#F5F5F5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 262.145H245.545V265.438H248.838V262.145Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 278.692H245.545V281.986H248.838V278.692Z",
    fill: "#F5F5F5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 284.213H245.545V287.506H248.838V284.213Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 289.733H245.545V293.027H248.838V289.733Z",
    fill: "#F5F5F5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M248.838 295.253H245.545V298.546H248.838V295.253Z",
    fill: "#F5F5F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 212.475H250.773V215.768H254.067V212.475Z",
    fill: "#F5F5F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 217.995H250.773V221.288H254.067V217.995Z",
    fill: "#F5F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 223.515H250.773V226.808H254.067V223.515Z",
    fill: "#F5F5F5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 229.035H250.773V232.328H254.067V229.035Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 234.544H250.773V237.837H254.067V234.544Z",
    fill: "#F5F5F5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 240.063H250.773V243.357H254.067V240.063Z",
    fill: "#F5F5F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 245.584H250.773V248.877H254.067V245.584Z",
    fill: "#F5F5F5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 251.104H250.773V254.397H254.067V251.104Z",
    fill: "#F5F5F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 256.624H250.773V259.917H254.067V256.624Z",
    fill: "#F5F5F5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 262.145H250.773V265.438H254.067V262.145Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 278.692H250.773V281.986H254.067V278.692Z",
    fill: "#F5F5F5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 284.213H250.773V287.506H254.067V284.213Z",
    fill: "#F5F5F5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M254.067 289.733H250.773V293.027H254.067V289.733Z",
    fill: "#F5F5F5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 198.142H309.631V201.435H312.924V198.142Z",
    fill: "#F5F5F5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 203.661H309.631V206.954H312.924V203.661Z",
    fill: "#F5F5F5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 209.182H309.631V212.475H312.924V209.182Z",
    fill: "#F5F5F5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 214.701H309.631V217.994H312.924V214.701Z",
    fill: "#F5F5F5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 220.222H309.631V223.515H312.924V220.222Z",
    fill: "#F5F5F5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 225.742H309.631V229.036H312.924V225.742Z",
    fill: "#F5F5F5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 231.262H309.631V234.555H312.924V231.262Z",
    fill: "#F5F5F5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 236.771H309.631V240.064H312.924V236.771Z",
    fill: "#F5F5F5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 253.331H309.631V256.624H312.924V253.331Z",
    fill: "#F5F5F5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M312.924 258.851H309.631V262.144H312.924V258.851Z",
    fill: "#F5F5F5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 198.142H314.857V201.435H318.151V198.142Z",
    fill: "#F5F5F5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 203.661H314.857V206.954H318.151V203.661Z",
    fill: "#F5F5F5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 209.182H314.857V212.475H318.151V209.182Z",
    fill: "#F5F5F5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 214.701H314.857V217.994H318.151V214.701Z",
    fill: "#F5F5F5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 220.222H314.857V223.515H318.151V220.222Z",
    fill: "#F5F5F5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 225.742H314.857V229.036H318.151V225.742Z",
    fill: "#F5F5F5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 231.262H314.857V234.555H318.151V231.262Z",
    fill: "#F5F5F5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 236.771H314.857V240.064H318.151V236.771Z",
    fill: "#F5F5F5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M318.151 258.851H314.857V262.144H318.151V258.851Z",
    fill: "#F5F5F5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 198.142H320.084V201.435H323.377V198.142Z",
    fill: "#F5F5F5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 203.661H320.084V206.954H323.377V203.661Z",
    fill: "#F5F5F5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 209.182H320.084V212.475H323.377V209.182Z",
    fill: "#F5F5F5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 214.701H320.084V217.994H323.377V214.701Z",
    fill: "#F5F5F5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 220.222H320.084V223.515H323.377V220.222Z",
    fill: "#F5F5F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 225.742H320.084V229.036H323.377V225.742Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 231.262H320.084V234.555H323.377V231.262Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 236.771H320.084V240.064H323.377V236.771Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 198.142H325.312V201.435H328.606V198.142Z",
    fill: "#F5F5F5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 203.661H325.312V206.954H328.606V203.661Z",
    fill: "#F5F5F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 209.182H325.312V212.475H328.606V209.182Z",
    fill: "#F5F5F5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 214.701H325.312V217.994H328.606V214.701Z",
    fill: "#F5F5F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 220.222H325.312V223.515H328.606V220.222Z",
    fill: "#F5F5F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 225.742H325.312V229.036H328.606V225.742Z",
    fill: "#F5F5F5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 236.771H325.312V240.064H328.606V236.771Z",
    fill: "#F5F5F5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 242.29H325.312V245.583H328.606V242.29Z",
    fill: "#F5F5F5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 258.851H325.312V262.144H328.606V258.851Z",
    fill: "#F5F5F5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 264.371H325.312V267.664H328.606V264.371Z",
    fill: "#F5F5F5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 269.879H325.312V273.172H328.606V269.879Z",
    fill: "#F5F5F5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 275.399H325.312V278.693H328.606V275.399Z",
    fill: "#F5F5F5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 280.92H325.312V284.213H328.606V280.92Z",
    fill: "#F5F5F5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 286.439H325.312V289.733H328.606V286.439Z",
    fill: "#F5F5F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 291.96H325.312V295.253H328.606V291.96Z",
    fill: "#F5F5F5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 198.142H330.539V201.435H333.832V198.142Z",
    fill: "#F5F5F5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 203.661H330.539V206.954H333.832V203.661Z",
    fill: "#F5F5F5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 209.182H330.539V212.475H333.832V209.182Z",
    fill: "#F5F5F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 214.701H330.539V217.994H333.832V214.701Z",
    fill: "#F5F5F5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 220.222H330.539V223.515H333.832V220.222Z",
    fill: "#F5F5F5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 225.742H330.539V229.036H333.832V225.742Z",
    fill: "#F5F5F5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 242.29H330.539V245.583H333.832V242.29Z",
    fill: "#F5F5F5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 247.811H330.539V251.104H333.832V247.811Z",
    fill: "#F5F5F5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 253.331H330.539V256.624H333.832V253.331Z",
    fill: "#F5F5F5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 258.851H330.539V262.144H333.832V258.851Z",
    fill: "#F5F5F5"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 264.371H330.539V267.664H333.832V264.371Z",
    fill: "#F5F5F5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 269.879H330.539V273.172H333.832V269.879Z",
    fill: "#F5F5F5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 275.399H330.539V278.693H333.832V275.399Z",
    fill: "#F5F5F5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 280.92H330.539V284.213H333.832V280.92Z",
    fill: "#F5F5F5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 286.439H330.539V289.733H333.832V286.439Z",
    fill: "#F5F5F5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 291.96H330.539V295.253H333.832V291.96Z",
    fill: "#F5F5F5"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 297.479H330.539V300.773H333.832V297.479Z",
    fill: "#F5F5F5"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M333.832 308.509H330.539V311.802H333.832V308.509Z",
    fill: "#F5F5F5"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 198.142H335.766V201.435H339.059V198.142Z",
    fill: "#F5F5F5"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 203.661H335.766V206.954H339.059V203.661Z",
    fill: "#F5F5F5"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 209.182H335.766V212.475H339.059V209.182Z",
    fill: "#F5F5F5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 214.701H335.766V217.994H339.059V214.701Z",
    fill: "#F5F5F5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 220.222H335.766V223.515H339.059V220.222Z",
    fill: "#F5F5F5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 225.742H335.766V229.036H339.059V225.742Z",
    fill: "#F5F5F5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 242.29H335.766V245.583H339.059V242.29Z",
    fill: "#F5F5F5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 247.811H335.766V251.104H339.059V247.811Z",
    fill: "#F5F5F5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 253.331H335.766V256.624H339.059V253.331Z",
    fill: "#F5F5F5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 258.851H335.766V262.144H339.059V258.851Z",
    fill: "#F5F5F5"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 275.399H335.766V278.693H339.059V275.399Z",
    fill: "#F5F5F5"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 280.92H335.766V284.213H339.059V280.92Z",
    fill: "#F5F5F5"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 286.439H335.766V289.733H339.059V286.439Z",
    fill: "#F5F5F5"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 291.96H335.766V295.253H339.059V291.96Z",
    fill: "#F5F5F5"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 297.479H335.766V300.773H339.059V297.479Z",
    fill: "#F5F5F5"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 308.509H335.766V311.802H339.059V308.509Z",
    fill: "#F5F5F5"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M339.059 314.028H335.766V317.322H339.059V314.028Z",
    fill: "#F5F5F5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 249.451H383.209V252.744H386.502V249.451Z",
    fill: "#F5F5F5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 254.972H383.209V258.265H386.502V254.972Z",
    fill: "#F5F5F5"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 260.491H383.209V263.785H386.502V260.491Z",
    fill: "#F5F5F5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 266.012H383.209V269.305H386.502V266.012Z",
    fill: "#F5F5F5"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 271.532H383.209V274.826H386.502V271.532Z",
    fill: "#F5F5F5"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 277.052H383.209V280.345H386.502V277.052Z",
    fill: "#F5F5F5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 282.572H383.209V285.866H386.502V282.572Z",
    fill: "#F5F5F5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 299.121H383.209V302.414H386.502V299.121Z",
    fill: "#F5F5F5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 304.641H383.209V307.934H386.502V304.641Z",
    fill: "#F5F5F5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M386.502 310.161H383.209V313.454H386.502V310.161Z",
    fill: "#F5F5F5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 249.451H388.436V252.744H391.729V249.451Z",
    fill: "#F5F5F5"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 254.972H388.436V258.265H391.729V254.972Z",
    fill: "#F5F5F5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 260.491H388.436V263.785H391.729V260.491Z",
    fill: "#F5F5F5"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 266.012H388.436V269.305H391.729V266.012Z",
    fill: "#F5F5F5"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 271.532H388.436V274.826H391.729V271.532Z",
    fill: "#F5F5F5"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 277.052H388.436V280.345H391.729V277.052Z",
    fill: "#F5F5F5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 282.572H388.436V285.866H391.729V282.572Z",
    fill: "#F5F5F5"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 249.451H393.664V252.744H396.957V249.451Z",
    fill: "#F5F5F5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 254.972H393.664V258.265H396.957V254.972Z",
    fill: "#F5F5F5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 260.491H393.664V263.785H396.957V260.491Z",
    fill: "#F5F5F5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 266.012H393.664V269.305H396.957V266.012Z",
    fill: "#F5F5F5"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 271.532H393.664V274.826H396.957V271.532Z",
    fill: "#F5F5F5"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 277.052H393.664V280.345H396.957V277.052Z",
    fill: "#F5F5F5"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M396.957 282.572H393.664V285.866H396.957V282.572Z",
    fill: "#F5F5F5"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 249.451H398.891V252.744H402.184V249.451Z",
    fill: "#F5F5F5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 254.972H398.891V258.265H402.184V254.972Z",
    fill: "#F5F5F5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 260.491H398.891V263.785H402.184V260.491Z",
    fill: "#F5F5F5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 266.012H398.891V269.305H402.184V266.012Z",
    fill: "#F5F5F5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 271.532H398.891V274.826H402.184V271.532Z",
    fill: "#F5F5F5"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 277.052H398.891V280.345H402.184V277.052Z",
    fill: "#F5F5F5"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 282.572H398.891V285.866H402.184V282.572Z",
    fill: "#F5F5F5"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 288.08H398.891V291.373H402.184V288.08Z",
    fill: "#F5F5F5"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 293.601H398.891V296.894H402.184V293.601Z",
    fill: "#F5F5F5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 299.121H398.891V302.414H402.184V299.121Z",
    fill: "#F5F5F5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M402.184 304.641H398.891V307.934H402.184V304.641Z",
    fill: "#F5F5F5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 249.451H404.117V252.744H407.411V249.451Z",
    fill: "#F5F5F5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 254.972H404.117V258.265H407.411V254.972Z",
    fill: "#F5F5F5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 260.491H404.117V263.785H407.411V260.491Z",
    fill: "#F5F5F5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 266.012H404.117V269.305H407.411V266.012Z",
    fill: "#F5F5F5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 271.532H404.117V274.826H407.411V271.532Z",
    fill: "#F5F5F5"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 277.052H404.117V280.345H407.411V277.052Z",
    fill: "#F5F5F5"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 282.572H404.117V285.866H407.411V282.572Z",
    fill: "#F5F5F5"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 288.08H404.117V291.373H407.411V288.08Z",
    fill: "#F5F5F5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 293.601H404.117V296.894H407.411V293.601Z",
    fill: "#F5F5F5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 299.121H404.117V302.414H407.411V299.121Z",
    fill: "#F5F5F5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 304.641H404.117V307.934H407.411V304.641Z",
    fill: "#F5F5F5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 310.161H404.117V313.454H407.411V310.161Z",
    fill: "#F5F5F5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 326.71H404.117V330.003H407.411V326.71Z",
    fill: "#F5F5F5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M407.411 332.229H404.117V335.523H407.411V332.229Z",
    fill: "#F5F5F5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 249.451H409.344V252.744H412.637V249.451Z",
    fill: "#F5F5F5"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 254.972H409.344V258.265H412.637V254.972Z",
    fill: "#F5F5F5"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 260.491H409.344V263.785H412.637V260.491Z",
    fill: "#F5F5F5"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 277.052H409.344V280.345H412.637V277.052Z",
    fill: "#F5F5F5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 282.572H409.344V285.866H412.637V282.572Z",
    fill: "#F5F5F5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 288.08H409.344V291.373H412.637V288.08Z",
    fill: "#F5F5F5"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 293.601H409.344V296.894H412.637V293.601Z",
    fill: "#F5F5F5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 299.121H409.344V302.414H412.637V299.121Z",
    fill: "#F5F5F5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 304.641H409.344V307.934H412.637V304.641Z",
    fill: "#F5F5F5"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 310.161H409.344V313.454H412.637V310.161Z",
    fill: "#F5F5F5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 326.71H409.344V330.003H412.637V326.71Z",
    fill: "#F5F5F5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 332.229H409.344V335.523H412.637V332.229Z",
    fill: "#F5F5F5"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M412.637 337.75H409.344V341.043H412.637V337.75Z",
    fill: "#F5F5F5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 216.343H464.135V219.636H467.428V216.343Z",
    fill: "#F5F5F5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 221.862H464.135V225.156H467.428V221.862Z",
    fill: "#F5F5F5"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 227.383H464.135V230.676H467.428V227.383Z",
    fill: "#F5F5F5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 232.902H464.135V236.196H467.428V232.902Z",
    fill: "#F5F5F5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 238.423H464.135V241.716H467.428V238.423Z",
    fill: "#F5F5F5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 243.943H464.135V247.237H467.428V243.943Z",
    fill: "#F5F5F5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 249.451H464.135V252.744H467.428V249.451Z",
    fill: "#F5F5F5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 254.972H464.135V258.265H467.428V254.972Z",
    fill: "#F5F5F5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 260.491H464.135V263.785H467.428V260.491Z",
    fill: "#F5F5F5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 266.012H464.135V269.305H467.428V266.012Z",
    fill: "#F5F5F5"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 271.532H464.135V274.826H467.428V271.532Z",
    fill: "#F5F5F5"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 277.052H464.135V280.345H467.428V277.052Z",
    fill: "#F5F5F5"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 282.572H464.135V285.866H467.428V282.572Z",
    fill: "#F5F5F5"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 288.08H464.135V291.373H467.428V288.08Z",
    fill: "#F5F5F5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 293.601H464.135V296.894H467.428V293.601Z",
    fill: "#F5F5F5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 299.121H464.135V302.414H467.428V299.121Z",
    fill: "#F5F5F5"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 304.641H464.135V307.934H467.428V304.641Z",
    fill: "#F5F5F5"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 310.161H464.135V313.454H467.428V310.161Z",
    fill: "#F5F5F5"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 315.681H464.135V318.974H467.428V315.681Z",
    fill: "#F5F5F5"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 321.189H464.135V324.483H467.428V321.189Z",
    fill: "#F5F5F5"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 326.71H464.135V330.003H467.428V326.71Z",
    fill: "#F5F5F5"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 332.229H464.135V335.523H467.428V332.229Z",
    fill: "#F5F5F5"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M467.428 337.75H464.135V341.043H467.428V337.75Z",
    fill: "#F5F5F5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 216.343H469.363V219.636H472.657V216.343Z",
    fill: "#F5F5F5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 221.862H469.363V225.156H472.657V221.862Z",
    fill: "#F5F5F5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 227.383H469.363V230.676H472.657V227.383Z",
    fill: "#F5F5F5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 232.902H469.363V236.196H472.657V232.902Z",
    fill: "#F5F5F5"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 238.423H469.363V241.716H472.657V238.423Z",
    fill: "#F5F5F5"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 243.943H469.363V247.237H472.657V243.943Z",
    fill: "#F5F5F5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 249.451H469.363V252.744H472.657V249.451Z",
    fill: "#F5F5F5"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 254.972H469.363V258.265H472.657V254.972Z",
    fill: "#F5F5F5"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 260.491H469.363V263.785H472.657V260.491Z",
    fill: "#F5F5F5"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 266.012H469.363V269.305H472.657V266.012Z",
    fill: "#F5F5F5"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 271.532H469.363V274.826H472.657V271.532Z",
    fill: "#F5F5F5"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 277.052H469.363V280.345H472.657V277.052Z",
    fill: "#F5F5F5"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 282.572H469.363V285.866H472.657V282.572Z",
    fill: "#F5F5F5"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 288.08H469.363V291.373H472.657V288.08Z",
    fill: "#F5F5F5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 293.601H469.363V296.894H472.657V293.601Z",
    fill: "#F5F5F5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 299.121H469.363V302.414H472.657V299.121Z",
    fill: "#F5F5F5"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 304.641H469.363V307.934H472.657V304.641Z",
    fill: "#F5F5F5"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 310.161H469.363V313.454H472.657V310.161Z",
    fill: "#F5F5F5"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M472.657 315.681H469.363V318.974H472.657V315.681Z",
    fill: "#F5F5F5"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 216.343H474.602V219.636H477.895V216.343Z",
    fill: "#F5F5F5"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 221.862H474.602V225.156H477.895V221.862Z",
    fill: "#F5F5F5"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 227.383H474.602V230.676H477.895V227.383Z",
    fill: "#F5F5F5"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 232.902H474.602V236.196H477.895V232.902Z",
    fill: "#F5F5F5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 238.423H474.602V241.716H477.895V238.423Z",
    fill: "#F5F5F5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 243.943H474.602V247.237H477.895V243.943Z",
    fill: "#F5F5F5"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 249.451H474.602V252.744H477.895V249.451Z",
    fill: "#F5F5F5"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 254.972H474.602V258.265H477.895V254.972Z",
    fill: "#F5F5F5"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 260.491H474.602V263.785H477.895V260.491Z",
    fill: "#F5F5F5"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 266.012H474.602V269.305H477.895V266.012Z",
    fill: "#F5F5F5"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 271.532H474.602V274.826H477.895V271.532Z",
    fill: "#F5F5F5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 277.052H474.602V280.345H477.895V277.052Z",
    fill: "#F5F5F5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 282.572H474.602V285.866H477.895V282.572Z",
    fill: "#F5F5F5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 288.08H474.602V291.373H477.895V288.08Z",
    fill: "#F5F5F5"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 293.601H474.602V296.894H477.895V293.601Z",
    fill: "#F5F5F5"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 299.121H474.602V302.414H477.895V299.121Z",
    fill: "#F5F5F5"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 304.641H474.602V307.934H477.895V304.641Z",
    fill: "#F5F5F5"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 310.161H474.602V313.454H477.895V310.161Z",
    fill: "#F5F5F5"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M477.895 315.681H474.602V318.974H477.895V315.681Z",
    fill: "#F5F5F5"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 216.343H479.828V219.636H483.121V216.343Z",
    fill: "#F5F5F5"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 221.862H479.828V225.156H483.121V221.862Z",
    fill: "#F5F5F5"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 227.383H479.828V230.676H483.121V227.383Z",
    fill: "#F5F5F5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 232.902H479.828V236.196H483.121V232.902Z",
    fill: "#F5F5F5"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 238.423H479.828V241.716H483.121V238.423Z",
    fill: "#F5F5F5"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 243.943H479.828V247.237H483.121V243.943Z",
    fill: "#F5F5F5"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 249.451H479.828V252.744H483.121V249.451Z",
    fill: "#F5F5F5"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 254.972H479.828V258.265H483.121V254.972Z",
    fill: "#F5F5F5"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 260.491H479.828V263.785H483.121V260.491Z",
    fill: "#F5F5F5"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 266.012H479.828V269.305H483.121V266.012Z",
    fill: "#F5F5F5"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 271.532H479.828V274.826H483.121V271.532Z",
    fill: "#F5F5F5"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 277.052H479.828V280.345H483.121V277.052Z",
    fill: "#F5F5F5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 282.572H479.828V285.866H483.121V282.572Z",
    fill: "#F5F5F5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 288.08H479.828V291.373H483.121V288.08Z",
    fill: "#F5F5F5"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M483.121 293.601H479.828V296.894H483.121V293.601Z",
    fill: "#F5F5F5"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 216.343H485.055V219.636H488.348V216.343Z",
    fill: "#F5F5F5"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 221.862H485.055V225.156H488.348V221.862Z",
    fill: "#F5F5F5"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 227.383H485.055V230.676H488.348V227.383Z",
    fill: "#F5F5F5"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 232.902H485.055V236.196H488.348V232.902Z",
    fill: "#F5F5F5"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 238.423H485.055V241.716H488.348V238.423Z",
    fill: "#F5F5F5"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 243.943H485.055V247.237H488.348V243.943Z",
    fill: "#F5F5F5"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 249.451H485.055V252.744H488.348V249.451Z",
    fill: "#F5F5F5"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 254.972H485.055V258.265H488.348V254.972Z",
    fill: "#F5F5F5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 260.491H485.055V263.785H488.348V260.491Z",
    fill: "#F5F5F5"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 266.012H485.055V269.305H488.348V266.012Z",
    fill: "#F5F5F5"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 271.532H485.055V274.826H488.348V271.532Z",
    fill: "#F5F5F5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 277.052H485.055V280.345H488.348V277.052Z",
    fill: "#F5F5F5"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M488.348 282.572H485.055V285.866H488.348V282.572Z",
    fill: "#F5F5F5"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 216.343H490.283V219.636H493.577V216.343Z",
    fill: "#F5F5F5"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 221.862H490.283V225.156H493.577V221.862Z",
    fill: "#F5F5F5"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 227.383H490.283V230.676H493.577V227.383Z",
    fill: "#F5F5F5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 232.902H490.283V236.196H493.577V232.902Z",
    fill: "#F5F5F5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 238.423H490.283V241.716H493.577V238.423Z",
    fill: "#F5F5F5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 243.943H490.283V247.237H493.577V243.943Z",
    fill: "#F5F5F5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 249.451H490.283V252.744H493.577V249.451Z",
    fill: "#F5F5F5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 254.972H490.283V258.265H493.577V254.972Z",
    fill: "#F5F5F5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 260.491H490.283V263.785H493.577V260.491Z",
    fill: "#F5F5F5"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 266.012H490.283V269.305H493.577V266.012Z",
    fill: "#F5F5F5"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 271.532H490.283V274.826H493.577V271.532Z",
    fill: "#F5F5F5"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M493.577 277.052H490.283V280.345H493.577V277.052Z",
    fill: "#F5F5F5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 256.624H106.137V259.917H109.43V256.624Z",
    fill: "#F5F5F5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 262.145H106.137V265.438H109.43V262.145Z",
    fill: "#F5F5F5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 267.652H106.137V270.946H109.43V267.652Z",
    fill: "#F5F5F5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 273.173H106.137V276.466H109.43V273.173Z",
    fill: "#F5F5F5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 278.692H106.137V281.986H109.43V278.692Z",
    fill: "#F5F5F5"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 284.213H106.137V287.506H109.43V284.213Z",
    fill: "#F5F5F5"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 289.733H106.137V293.027H109.43V289.733Z",
    fill: "#F5F5F5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 295.253H106.137V298.546H109.43V295.253Z",
    fill: "#F5F5F5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 300.762H106.137V304.055H109.43V300.762Z",
    fill: "#F5F5F5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 306.281H106.137V309.575H109.43V306.281Z",
    fill: "#F5F5F5"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 311.802H106.137V315.095H109.43V311.802Z",
    fill: "#F5F5F5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 317.322H106.137V320.616H109.43V317.322Z",
    fill: "#F5F5F5"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 322.842H106.137V326.135H109.43V322.842Z",
    fill: "#F5F5F5"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 328.362H106.137V331.656H109.43V328.362Z",
    fill: "#F5F5F5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 333.87H106.137V337.163H109.43V333.87Z",
    fill: "#F5F5F5"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 339.391H106.137V342.684H109.43V339.391Z",
    fill: "#F5F5F5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 344.911H106.137V348.204H109.43V344.911Z",
    fill: "#F5F5F5"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 350.431H106.137V353.724H109.43V350.431Z",
    fill: "#F5F5F5"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 355.951H106.137V359.244H109.43V355.951Z",
    fill: "#F5F5F5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M109.43 361.471H106.137V364.764H109.43V361.471Z",
    fill: "#F5F5F5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 256.624H111.363V259.917H114.657V256.624Z",
    fill: "#F5F5F5"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 262.145H111.363V265.438H114.657V262.145Z",
    fill: "#F5F5F5"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 267.652H111.363V270.946H114.657V267.652Z",
    fill: "#F5F5F5"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 273.173H111.363V276.466H114.657V273.173Z",
    fill: "#F5F5F5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 278.692H111.363V281.986H114.657V278.692Z",
    fill: "#F5F5F5"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 284.213H111.363V287.506H114.657V284.213Z",
    fill: "#F5F5F5"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 289.733H111.363V293.027H114.657V289.733Z",
    fill: "#F5F5F5"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 295.253H111.363V298.546H114.657V295.253Z",
    fill: "#F5F5F5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 300.762H111.363V304.055H114.657V300.762Z",
    fill: "#F5F5F5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 306.281H111.363V309.575H114.657V306.281Z",
    fill: "#F5F5F5"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 311.802H111.363V315.095H114.657V311.802Z",
    fill: "#F5F5F5"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 317.322H111.363V320.616H114.657V317.322Z",
    fill: "#F5F5F5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 322.842H111.363V326.135H114.657V322.842Z",
    fill: "#F5F5F5"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 328.362H111.363V331.656H114.657V328.362Z",
    fill: "#F5F5F5"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 333.87H111.363V337.163H114.657V333.87Z",
    fill: "#F5F5F5"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 339.391H111.363V342.684H114.657V339.391Z",
    fill: "#F5F5F5"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 344.911H111.363V348.204H114.657V344.911Z",
    fill: "#F5F5F5"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M114.657 350.431H111.363V353.724H114.657V350.431Z",
    fill: "#F5F5F5"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 256.624H116.59V259.917H119.883V256.624Z",
    fill: "#F5F5F5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 262.145H116.59V265.438H119.883V262.145Z",
    fill: "#F5F5F5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 267.652H116.59V270.946H119.883V267.652Z",
    fill: "#F5F5F5"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 273.173H116.59V276.466H119.883V273.173Z",
    fill: "#F5F5F5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 278.692H116.59V281.986H119.883V278.692Z",
    fill: "#F5F5F5"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 284.213H116.59V287.506H119.883V284.213Z",
    fill: "#F5F5F5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 289.733H116.59V293.027H119.883V289.733Z",
    fill: "#F5F5F5"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 295.253H116.59V298.546H119.883V295.253Z",
    fill: "#F5F5F5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 300.762H116.59V304.055H119.883V300.762Z",
    fill: "#F5F5F5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 306.281H116.59V309.575H119.883V306.281Z",
    fill: "#F5F5F5"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 311.802H116.59V315.095H119.883V311.802Z",
    fill: "#F5F5F5"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 317.322H116.59V320.616H119.883V317.322Z",
    fill: "#F5F5F5"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 322.842H116.59V326.135H119.883V322.842Z",
    fill: "#F5F5F5"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 328.362H116.59V331.656H119.883V328.362Z",
    fill: "#F5F5F5"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 333.87H116.59V337.163H119.883V333.87Z",
    fill: "#F5F5F5"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 339.391H116.59V342.684H119.883V339.391Z",
    fill: "#F5F5F5"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 344.911H116.59V348.204H119.883V344.911Z",
    fill: "#F5F5F5"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M119.883 350.431H116.59V353.724H119.883V350.431Z",
    fill: "#F5F5F5"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 296.894H86.5762V300.187H89.8695V296.894Z",
    fill: "#F5F5F5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 302.414H86.5762V305.707H89.8695V302.414Z",
    fill: "#F5F5F5"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 307.935H86.5762V311.228H89.8695V307.935Z",
    fill: "#F5F5F5"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 313.454H86.5762V316.747H89.8695V313.454Z",
    fill: "#F5F5F5"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 318.963H86.5762V322.256H89.8695V318.963Z",
    fill: "#F5F5F5"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 324.482H86.5762V327.776H89.8695V324.482Z",
    fill: "#F5F5F5"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 330.003H86.5762V333.296H89.8695V330.003Z",
    fill: "#F5F5F5"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 335.523H86.5762V338.817H89.8695V335.523Z",
    fill: "#F5F5F5"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 341.043H86.5762V344.336H89.8695V341.043Z",
    fill: "#F5F5F5"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 346.563H86.5762V349.857H89.8695V346.563Z",
    fill: "#F5F5F5"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 352.071H86.5762V355.365H89.8695V352.071Z",
    fill: "#F5F5F5"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 357.592H86.5762V360.885H89.8695V357.592Z",
    fill: "#F5F5F5"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8695 363.112H86.5762V366.406H89.8695V363.112Z",
    fill: "#F5F5F5"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 296.894H91.8027V300.187H95.0961V296.894Z",
    fill: "#F5F5F5"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 302.414H91.8027V305.707H95.0961V302.414Z",
    fill: "#F5F5F5"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 307.935H91.8027V311.228H95.0961V307.935Z",
    fill: "#F5F5F5"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 313.454H91.8027V316.747H95.0961V313.454Z",
    fill: "#F5F5F5"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 318.963H91.8027V322.256H95.0961V318.963Z",
    fill: "#F5F5F5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 324.482H91.8027V327.776H95.0961V324.482Z",
    fill: "#F5F5F5"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 330.003H91.8027V333.296H95.0961V330.003Z",
    fill: "#F5F5F5"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 335.523H91.8027V338.817H95.0961V335.523Z",
    fill: "#F5F5F5"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 341.043H91.8027V344.336H95.0961V341.043Z",
    fill: "#F5F5F5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 346.563H91.8027V349.857H95.0961V346.563Z",
    fill: "#F5F5F5"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 352.071H91.8027V355.365H95.0961V352.071Z",
    fill: "#F5F5F5"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 357.592H91.8027V360.885H95.0961V357.592Z",
    fill: "#F5F5F5"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0961 363.112H91.8027V366.406H95.0961V363.112Z",
    fill: "#F5F5F5"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 296.894H97.0293V300.187H100.323V296.894Z",
    fill: "#F5F5F5"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 302.414H97.0293V305.707H100.323V302.414Z",
    fill: "#F5F5F5"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 307.935H97.0293V311.228H100.323V307.935Z",
    fill: "#F5F5F5"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 313.454H97.0293V316.747H100.323V313.454Z",
    fill: "#F5F5F5"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 318.963H97.0293V322.256H100.323V318.963Z",
    fill: "#F5F5F5"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 324.482H97.0293V327.776H100.323V324.482Z",
    fill: "#F5F5F5"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 330.003H97.0293V333.296H100.323V330.003Z",
    fill: "#F5F5F5"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 335.523H97.0293V338.817H100.323V335.523Z",
    fill: "#F5F5F5"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 341.043H97.0293V344.336H100.323V341.043Z",
    fill: "#F5F5F5"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 346.563H97.0293V349.857H100.323V346.563Z",
    fill: "#F5F5F5"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 352.071H97.0293V355.365H100.323V352.071Z",
    fill: "#F5F5F5"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 357.592H97.0293V360.885H100.323V357.592Z",
    fill: "#F5F5F5"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 363.112H97.0293V366.406H100.323V363.112Z",
    fill: "#F5F5F5"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 368.632H97.0293V371.925H100.323V368.632Z",
    fill: "#F5F5F5"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 298.535H126.072V301.829H129.366V298.535Z",
    fill: "#F5F5F5"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 304.055H126.072V307.348H129.366V304.055Z",
    fill: "#F5F5F5"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 309.575H126.072V312.869H129.366V309.575Z",
    fill: "#F5F5F5"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 315.095H126.072V318.388H129.366V315.095Z",
    fill: "#F5F5F5"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 320.615H126.072V323.909H129.366V320.615Z",
    fill: "#F5F5F5"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 326.136H126.072V329.429H129.366V326.136Z",
    fill: "#F5F5F5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 331.655H126.072V334.949H129.366V331.655Z",
    fill: "#F5F5F5"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 337.164H126.072V340.457H129.366V337.164Z",
    fill: "#F5F5F5"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 342.684H126.072V345.977H129.366V342.684Z",
    fill: "#F5F5F5"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 348.204H126.072V351.497H129.366V348.204Z",
    fill: "#F5F5F5"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M129.366 364.765H126.072V368.058H129.366V364.765Z",
    fill: "#F5F5F5"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 298.535H131.299V301.829H134.592V298.535Z",
    fill: "#F5F5F5"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 304.055H131.299V307.348H134.592V304.055Z",
    fill: "#F5F5F5"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 309.575H131.299V312.869H134.592V309.575Z",
    fill: "#F5F5F5"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 315.095H131.299V318.388H134.592V315.095Z",
    fill: "#F5F5F5"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 320.615H131.299V323.909H134.592V320.615Z",
    fill: "#F5F5F5"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 326.136H131.299V329.429H134.592V326.136Z",
    fill: "#F5F5F5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 331.655H131.299V334.949H134.592V331.655Z",
    fill: "#F5F5F5"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 337.164H131.299V340.457H134.592V337.164Z",
    fill: "#F5F5F5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 342.684H131.299V345.977H134.592V342.684Z",
    fill: "#F5F5F5"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 359.244H131.299V362.537H134.592V359.244Z",
    fill: "#F5F5F5"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 364.765H131.299V368.058H134.592V364.765Z",
    fill: "#F5F5F5"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 298.535H136.525V301.829H139.819V298.535Z",
    fill: "#F5F5F5"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 304.055H136.525V307.348H139.819V304.055Z",
    fill: "#F5F5F5"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 309.575H136.525V312.869H139.819V309.575Z",
    fill: "#F5F5F5"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 315.095H136.525V318.388H139.819V315.095Z",
    fill: "#F5F5F5"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 320.615H136.525V323.909H139.819V320.615Z",
    fill: "#F5F5F5"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 326.136H136.525V329.429H139.819V326.136Z",
    fill: "#F5F5F5"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 331.655H136.525V334.949H139.819V331.655Z",
    fill: "#F5F5F5"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 337.164H136.525V340.457H139.819V337.164Z",
    fill: "#F5F5F5"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 353.725H136.525V357.018H139.819V353.725Z",
    fill: "#F5F5F5"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 359.244H136.525V362.537H139.819V359.244Z",
    fill: "#F5F5F5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M139.819 364.765H136.525V368.058H139.819V364.765Z",
    fill: "#F5F5F5"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 214.701H185.129V217.994H188.422V214.701Z",
    fill: "#F5F5F5"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 220.222H185.129V223.515H188.422V220.222Z",
    fill: "#F5F5F5"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 225.742H185.129V229.036H188.422V225.742Z",
    fill: "#F5F5F5"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 231.262H185.129V234.555H188.422V231.262Z",
    fill: "#F5F5F5"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 236.771H185.129V240.064H188.422V236.771Z",
    fill: "#F5F5F5"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 242.29H185.129V245.583H188.422V242.29Z",
    fill: "#F5F5F5"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 247.811H185.129V251.104H188.422V247.811Z",
    fill: "#F5F5F5"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 253.331H185.129V256.624H188.422V253.331Z",
    fill: "#F5F5F5"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 258.851H185.129V262.144H188.422V258.851Z",
    fill: "#F5F5F5"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 264.371H185.129V267.664H188.422V264.371Z",
    fill: "#F5F5F5"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 269.879H185.129V273.172H188.422V269.879Z",
    fill: "#F5F5F5"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 275.399H185.129V278.693H188.422V275.399Z",
    fill: "#F5F5F5"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 280.92H185.129V284.213H188.422V280.92Z",
    fill: "#F5F5F5"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 286.439H185.129V289.733H188.422V286.439Z",
    fill: "#F5F5F5"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 291.96H185.129V295.253H188.422V291.96Z",
    fill: "#F5F5F5"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 297.479H185.129V300.773H188.422V297.479Z",
    fill: "#F5F5F5"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 302.988H185.129V306.282H188.422V302.988Z",
    fill: "#F5F5F5"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 314.028H185.129V317.322H188.422V314.028Z",
    fill: "#F5F5F5"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 319.549H185.129V322.842H188.422V319.549Z",
    fill: "#F5F5F5"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 325.068H185.129V328.362H188.422V325.068Z",
    fill: "#F5F5F5"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 330.589H185.129V333.882H188.422V330.589Z",
    fill: "#F5F5F5"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M188.422 336.098H185.129V339.391H188.422V336.098Z",
    fill: "#F5F5F5"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 214.701H190.355V217.994H193.649V214.701Z",
    fill: "#F5F5F5"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 220.222H190.355V223.515H193.649V220.222Z",
    fill: "#F5F5F5"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 225.742H190.355V229.036H193.649V225.742Z",
    fill: "#F5F5F5"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 231.262H190.355V234.555H193.649V231.262Z",
    fill: "#F5F5F5"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 236.771H190.355V240.064H193.649V236.771Z",
    fill: "#F5F5F5"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 242.29H190.355V245.583H193.649V242.29Z",
    fill: "#F5F5F5"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 247.811H190.355V251.104H193.649V247.811Z",
    fill: "#F5F5F5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 253.331H190.355V256.624H193.649V253.331Z",
    fill: "#F5F5F5"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 258.851H190.355V262.144H193.649V258.851Z",
    fill: "#F5F5F5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 264.371H190.355V267.664H193.649V264.371Z",
    fill: "#F5F5F5"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 269.879H190.355V273.172H193.649V269.879Z",
    fill: "#F5F5F5"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 275.399H190.355V278.693H193.649V275.399Z",
    fill: "#F5F5F5"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 280.92H190.355V284.213H193.649V280.92Z",
    fill: "#F5F5F5"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 286.439H190.355V289.733H193.649V286.439Z",
    fill: "#F5F5F5"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 291.96H190.355V295.253H193.649V291.96Z",
    fill: "#F5F5F5"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 297.479H190.355V300.773H193.649V297.479Z",
    fill: "#F5F5F5"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 330.589H190.355V333.882H193.649V330.589Z",
    fill: "#F5F5F5"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M193.649 336.098H190.355V339.391H193.649V336.098Z",
    fill: "#F5F5F5"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 214.701H195.584V217.994H198.877V214.701Z",
    fill: "#F5F5F5"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 220.222H195.584V223.515H198.877V220.222Z",
    fill: "#F5F5F5"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 225.742H195.584V229.036H198.877V225.742Z",
    fill: "#F5F5F5"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 231.262H195.584V234.555H198.877V231.262Z",
    fill: "#F5F5F5"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 236.771H195.584V240.064H198.877V236.771Z",
    fill: "#F5F5F5"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 242.29H195.584V245.583H198.877V242.29Z",
    fill: "#F5F5F5"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 247.811H195.584V251.104H198.877V247.811Z",
    fill: "#F5F5F5"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 253.331H195.584V256.624H198.877V253.331Z",
    fill: "#F5F5F5"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 258.851H195.584V262.144H198.877V258.851Z",
    fill: "#F5F5F5"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 264.371H195.584V267.664H198.877V264.371Z",
    fill: "#F5F5F5"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 269.879H195.584V273.172H198.877V269.879Z",
    fill: "#F5F5F5"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 275.399H195.584V278.693H198.877V275.399Z",
    fill: "#F5F5F5"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 280.92H195.584V284.213H198.877V280.92Z",
    fill: "#F5F5F5"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 286.439H195.584V289.733H198.877V286.439Z",
    fill: "#F5F5F5"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 291.96H195.584V295.253H198.877V291.96Z",
    fill: "#F5F5F5"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 297.479H195.584V300.773H198.877V297.479Z",
    fill: "#F5F5F5"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 308.509H195.584V311.802H198.877V308.509Z",
    fill: "#F5F5F5"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 314.028H195.584V317.322H198.877V314.028Z",
    fill: "#F5F5F5"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 319.549H195.584V322.842H198.877V319.549Z",
    fill: "#F5F5F5"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 325.068H195.584V328.362H198.877V325.068Z",
    fill: "#F5F5F5"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 336.098H195.584V339.391H198.877V336.098Z",
    fill: "#F5F5F5"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 284.213H166.154V287.506H169.448V284.213Z",
    fill: "#F5F5F5"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 289.733H166.154V293.027H169.448V289.733Z",
    fill: "#F5F5F5"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 295.253H166.154V298.546H169.448V295.253Z",
    fill: "#F5F5F5"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 300.762H166.154V304.055H169.448V300.762Z",
    fill: "#F5F5F5"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 306.281H166.154V309.575H169.448V306.281Z",
    fill: "#F5F5F5"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 311.802H166.154V315.095H169.448V311.802Z",
    fill: "#F5F5F5"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 317.322H166.154V320.616H169.448V317.322Z",
    fill: "#F5F5F5"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 328.362H166.154V331.656H169.448V328.362Z",
    fill: "#F5F5F5"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 333.87H166.154V337.163H169.448V333.87Z",
    fill: "#F5F5F5"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 339.391H166.154V342.684H169.448V339.391Z",
    fill: "#F5F5F5"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 344.911H166.154V348.204H169.448V344.911Z",
    fill: "#F5F5F5"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 350.431H166.154V353.724H169.448V350.431Z",
    fill: "#F5F5F5"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 355.951H166.154V359.244H169.448V355.951Z",
    fill: "#F5F5F5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 361.471H166.154V364.764H169.448V361.471Z",
    fill: "#F5F5F5"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 366.991H166.154V370.285H169.448V366.991Z",
    fill: "#F5F5F5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 284.213H171.381V287.506H174.674V284.213Z",
    fill: "#F5F5F5"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 289.733H171.381V293.027H174.674V289.733Z",
    fill: "#F5F5F5"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 295.253H171.381V298.546H174.674V295.253Z",
    fill: "#F5F5F5"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 300.762H171.381V304.055H174.674V300.762Z",
    fill: "#F5F5F5"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 306.281H171.381V309.575H174.674V306.281Z",
    fill: "#F5F5F5"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 311.802H171.381V315.095H174.674V311.802Z",
    fill: "#F5F5F5"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 328.362H171.381V331.656H174.674V328.362Z",
    fill: "#F5F5F5"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 333.87H171.381V337.163H174.674V333.87Z",
    fill: "#F5F5F5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 339.391H171.381V342.684H174.674V339.391Z",
    fill: "#F5F5F5"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 344.911H171.381V348.204H174.674V344.911Z",
    fill: "#F5F5F5"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 350.431H171.381V353.724H174.674V350.431Z",
    fill: "#F5F5F5"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 355.951H171.381V359.244H174.674V355.951Z",
    fill: "#F5F5F5"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 361.471H171.381V364.764H174.674V361.471Z",
    fill: "#F5F5F5"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M174.674 366.991H171.381V370.285H174.674V366.991Z",
    fill: "#F5F5F5"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 284.213H176.609V287.506H179.903V284.213Z",
    fill: "#F5F5F5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 289.733H176.609V293.027H179.903V289.733Z",
    fill: "#F5F5F5"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 295.253H176.609V298.546H179.903V295.253Z",
    fill: "#F5F5F5"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 300.762H176.609V304.055H179.903V300.762Z",
    fill: "#F5F5F5"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 306.281H176.609V309.575H179.903V306.281Z",
    fill: "#F5F5F5"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 311.802H176.609V315.095H179.903V311.802Z",
    fill: "#F5F5F5"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 322.842H176.609V326.135H179.903V322.842Z",
    fill: "#F5F5F5"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 328.362H176.609V331.656H179.903V328.362Z",
    fill: "#F5F5F5"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 333.87H176.609V337.163H179.903V333.87Z",
    fill: "#F5F5F5"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 339.391H176.609V342.684H179.903V339.391Z",
    fill: "#F5F5F5"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 344.911H176.609V348.204H179.903V344.911Z",
    fill: "#F5F5F5"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 350.431H176.609V353.724H179.903V350.431Z",
    fill: "#F5F5F5"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 355.951H176.609V359.244H179.903V355.951Z",
    fill: "#F5F5F5"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 361.471H176.609V364.764H179.903V361.471Z",
    fill: "#F5F5F5"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M179.903 366.991H176.609V370.285H179.903V366.991Z",
    fill: "#F5F5F5"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 253.331H286.777V256.624H290.071V253.331Z",
    fill: "#F5F5F5"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 258.851H286.777V262.144H290.071V258.851Z",
    fill: "#F5F5F5"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 264.371H286.777V267.664H290.071V264.371Z",
    fill: "#F5F5F5"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 269.879H286.777V273.172H290.071V269.879Z",
    fill: "#F5F5F5"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 275.399H286.777V278.693H290.071V275.399Z",
    fill: "#F5F5F5"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 280.92H286.777V284.213H290.071V280.92Z",
    fill: "#F5F5F5"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 286.439H286.777V289.733H290.071V286.439Z",
    fill: "#F5F5F5"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 291.96H286.777V295.253H290.071V291.96Z",
    fill: "#F5F5F5"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 297.479H286.777V300.773H290.071V297.479Z",
    fill: "#F5F5F5"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 302.988H286.777V306.282H290.071V302.988Z",
    fill: "#F5F5F5"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 308.509H286.777V311.802H290.071V308.509Z",
    fill: "#F5F5F5"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 314.028H286.777V317.322H290.071V314.028Z",
    fill: "#F5F5F5"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 319.549H286.777V322.842H290.071V319.549Z",
    fill: "#F5F5F5"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 330.589H286.777V333.882H290.071V330.589Z",
    fill: "#F5F5F5"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 336.098H286.777V339.391H290.071V336.098Z",
    fill: "#F5F5F5"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 341.617H286.777V344.911H290.071V341.617Z",
    fill: "#F5F5F5"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 347.138H286.777V350.431H290.071V347.138Z",
    fill: "#F5F5F5"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 358.178H286.777V361.471H290.071V358.178Z",
    fill: "#F5F5F5"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 363.698H286.777V366.992H290.071V363.698Z",
    fill: "#F5F5F5"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 369.218H286.777V372.511H290.071V369.218Z",
    fill: "#F5F5F5"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 253.331H292.016V256.624H295.309V253.331Z",
    fill: "#F5F5F5"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 258.851H292.016V262.144H295.309V258.851Z",
    fill: "#F5F5F5"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 264.371H292.016V267.664H295.309V264.371Z",
    fill: "#F5F5F5"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 269.879H292.016V273.172H295.309V269.879Z",
    fill: "#F5F5F5"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 275.399H292.016V278.693H295.309V275.399Z",
    fill: "#F5F5F5"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 280.92H292.016V284.213H295.309V280.92Z",
    fill: "#F5F5F5"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 286.439H292.016V289.733H295.309V286.439Z",
    fill: "#F5F5F5"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 291.96H292.016V295.253H295.309V291.96Z",
    fill: "#F5F5F5"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 297.479H292.016V300.773H295.309V297.479Z",
    fill: "#F5F5F5"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 302.988H292.016V306.282H295.309V302.988Z",
    fill: "#F5F5F5"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 308.509H292.016V311.802H295.309V308.509Z",
    fill: "#F5F5F5"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 314.028H292.016V317.322H295.309V314.028Z",
    fill: "#F5F5F5"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 319.549H292.016V322.842H295.309V319.549Z",
    fill: "#F5F5F5"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 336.098H292.016V339.391H295.309V336.098Z",
    fill: "#F5F5F5"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 341.617H292.016V344.911H295.309V341.617Z",
    fill: "#F5F5F5"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 352.657H292.016V355.951H295.309V352.657Z",
    fill: "#F5F5F5"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 358.178H292.016V361.471H295.309V358.178Z",
    fill: "#F5F5F5"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 363.698H292.016V366.992H295.309V363.698Z",
    fill: "#F5F5F5"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M295.309 369.218H292.016V372.511H295.309V369.218Z",
    fill: "#F5F5F5"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 253.331H297.242V256.624H300.536V253.331Z",
    fill: "#F5F5F5"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 258.851H297.242V262.144H300.536V258.851Z",
    fill: "#F5F5F5"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 264.371H297.242V267.664H300.536V264.371Z",
    fill: "#F5F5F5"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 269.879H297.242V273.172H300.536V269.879Z",
    fill: "#F5F5F5"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 275.399H297.242V278.693H300.536V275.399Z",
    fill: "#F5F5F5"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 280.92H297.242V284.213H300.536V280.92Z",
    fill: "#F5F5F5"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 286.439H297.242V289.733H300.536V286.439Z",
    fill: "#F5F5F5"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 291.96H297.242V295.253H300.536V291.96Z",
    fill: "#F5F5F5"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 297.479H297.242V300.773H300.536V297.479Z",
    fill: "#F5F5F5"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 302.988H297.242V306.282H300.536V302.988Z",
    fill: "#F5F5F5"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 308.509H297.242V311.802H300.536V308.509Z",
    fill: "#F5F5F5"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 314.028H297.242V317.322H300.536V314.028Z",
    fill: "#F5F5F5"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 319.549H297.242V322.842H300.536V319.549Z",
    fill: "#F5F5F5"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 325.068H297.242V328.362H300.536V325.068Z",
    fill: "#F5F5F5"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 336.098H297.242V339.391H300.536V336.098Z",
    fill: "#F5F5F5"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 347.138H297.242V350.431H300.536V347.138Z",
    fill: "#F5F5F5"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 352.657H297.242V355.951H300.536V352.657Z",
    fill: "#F5F5F5"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 358.178H297.242V361.471H300.536V358.178Z",
    fill: "#F5F5F5"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 363.698H297.242V366.992H300.536V363.698Z",
    fill: "#F5F5F5"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M300.536 369.218H297.242V372.511H300.536V369.218Z",
    fill: "#F5F5F5"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 284.799H265.48V288.092H268.774V284.799Z",
    fill: "#F5F5F5"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 290.308H265.48V293.601H268.774V290.308Z",
    fill: "#F5F5F5"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 295.827H265.48V299.12H268.774V295.827Z",
    fill: "#F5F5F5"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 301.348H265.48V304.641H268.774V301.348Z",
    fill: "#F5F5F5"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 306.867H265.48V310.161H268.774V306.867Z",
    fill: "#F5F5F5"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 312.388H265.48V315.681H268.774V312.388Z",
    fill: "#F5F5F5"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 328.937H265.48V332.23H268.774V328.937Z",
    fill: "#F5F5F5"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 334.457H265.48V337.75H268.774V334.457Z",
    fill: "#F5F5F5"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 339.977H265.48V343.27H268.774V339.977Z",
    fill: "#F5F5F5"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 345.497H265.48V348.79H268.774V345.497Z",
    fill: "#F5F5F5"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 351.017H265.48V354.31H268.774V351.017Z",
    fill: "#F5F5F5"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 356.525H265.48V359.819H268.774V356.525Z",
    fill: "#F5F5F5"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M268.774 362.045H265.48V365.338H268.774V362.045Z",
    fill: "#F5F5F5"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 284.799H270.709V288.092H274.002V284.799Z",
    fill: "#F5F5F5"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 290.308H270.709V293.601H274.002V290.308Z",
    fill: "#F5F5F5"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 295.827H270.709V299.12H274.002V295.827Z",
    fill: "#F5F5F5"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 301.348H270.709V304.641H274.002V301.348Z",
    fill: "#F5F5F5"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 306.867H270.709V310.161H274.002V306.867Z",
    fill: "#F5F5F5"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 312.388H270.709V315.681H274.002V312.388Z",
    fill: "#F5F5F5"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 328.937H270.709V332.23H274.002V328.937Z",
    fill: "#F5F5F5"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 334.457H270.709V337.75H274.002V334.457Z",
    fill: "#F5F5F5"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 339.977H270.709V343.27H274.002V339.977Z",
    fill: "#F5F5F5"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 345.497H270.709V348.79H274.002V345.497Z",
    fill: "#F5F5F5"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 351.017H270.709V354.31H274.002V351.017Z",
    fill: "#F5F5F5"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 356.525H270.709V359.819H274.002V356.525Z",
    fill: "#F5F5F5"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M274.002 367.565H270.709V370.859H274.002V367.565Z",
    fill: "#F5F5F5"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 260.491H444.387V263.785H447.68V260.491Z",
    fill: "#F5F5F5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 266.012H444.387V269.305H447.68V266.012Z",
    fill: "#F5F5F5"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 271.532H444.387V274.826H447.68V271.532Z",
    fill: "#F5F5F5"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 277.052H444.387V280.345H447.68V277.052Z",
    fill: "#F5F5F5"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 282.572H444.387V285.866H447.68V282.572Z",
    fill: "#F5F5F5"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 288.08H444.387V291.373H447.68V288.08Z",
    fill: "#F5F5F5"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 293.601H444.387V296.894H447.68V293.601Z",
    fill: "#F5F5F5"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 299.121H444.387V302.414H447.68V299.121Z",
    fill: "#F5F5F5"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 304.641H444.387V307.934H447.68V304.641Z",
    fill: "#F5F5F5"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 310.161H444.387V313.454H447.68V310.161Z",
    fill: "#F5F5F5"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 315.681H444.387V318.974H447.68V315.681Z",
    fill: "#F5F5F5"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 326.71H444.387V330.003H447.68V326.71Z",
    fill: "#F5F5F5"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 332.229H444.387V335.523H447.68V332.229Z",
    fill: "#F5F5F5"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 337.75H444.387V341.043H447.68V337.75Z",
    fill: "#F5F5F5"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 343.27H444.387V346.563H447.68V343.27Z",
    fill: "#F5F5F5"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 348.79H444.387V352.083H447.68V348.79Z",
    fill: "#F5F5F5"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 354.299H444.387V357.592H447.68V354.299Z",
    fill: "#F5F5F5"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 359.818H444.387V363.112H447.68V359.818Z",
    fill: "#F5F5F5"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 365.339H444.387V368.632H447.68V365.339Z",
    fill: "#F5F5F5"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 260.491H449.615V263.785H452.909V260.491Z",
    fill: "#F5F5F5"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 266.012H449.615V269.305H452.909V266.012Z",
    fill: "#F5F5F5"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 271.532H449.615V274.826H452.909V271.532Z",
    fill: "#F5F5F5"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 277.052H449.615V280.345H452.909V277.052Z",
    fill: "#F5F5F5"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 282.572H449.615V285.866H452.909V282.572Z",
    fill: "#F5F5F5"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 288.08H449.615V291.373H452.909V288.08Z",
    fill: "#F5F5F5"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 293.601H449.615V296.894H452.909V293.601Z",
    fill: "#F5F5F5"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 299.121H449.615V302.414H452.909V299.121Z",
    fill: "#F5F5F5"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 304.641H449.615V307.934H452.909V304.641Z",
    fill: "#F5F5F5"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 310.161H449.615V313.454H452.909V310.161Z",
    fill: "#F5F5F5"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 315.681H449.615V318.974H452.909V315.681Z",
    fill: "#F5F5F5"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 321.189H449.615V324.483H452.909V321.189Z",
    fill: "#F5F5F5"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 326.71H449.615V330.003H452.909V326.71Z",
    fill: "#F5F5F5"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 332.229H449.615V335.523H452.909V332.229Z",
    fill: "#F5F5F5"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 337.75H449.615V341.043H452.909V337.75Z",
    fill: "#F5F5F5"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 343.27H449.615V346.563H452.909V343.27Z",
    fill: "#F5F5F5"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 348.79H449.615V352.083H452.909V348.79Z",
    fill: "#F5F5F5"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 354.299H449.615V357.592H452.909V354.299Z",
    fill: "#F5F5F5"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 359.818H449.615V363.112H452.909V359.818Z",
    fill: "#F5F5F5"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M452.909 365.339H449.615V368.632H452.909V365.339Z",
    fill: "#F5F5F5"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 281.986H418.639V285.28H421.932V281.986Z",
    fill: "#F5F5F5"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 287.506H418.639V290.799H421.932V287.506Z",
    fill: "#F5F5F5"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 293.026H418.639V296.32H421.932V293.026Z",
    fill: "#F5F5F5"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 298.535H418.639V301.829H421.932V298.535Z",
    fill: "#F5F5F5"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 304.055H418.639V307.348H421.932V304.055Z",
    fill: "#F5F5F5"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 309.575H418.639V312.869H421.932V309.575Z",
    fill: "#F5F5F5"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 315.095H418.639V318.388H421.932V315.095Z",
    fill: "#F5F5F5"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 320.615H418.639V323.909H421.932V320.615Z",
    fill: "#F5F5F5"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 326.136H418.639V329.429H421.932V326.136Z",
    fill: "#F5F5F5"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M421.932 331.655H418.639V334.949H421.932V331.655Z",
    fill: "#F5F5F5"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 281.986H423.865V285.28H427.159V281.986Z",
    fill: "#F5F5F5"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 287.506H423.865V290.799H427.159V287.506Z",
    fill: "#F5F5F5"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 293.026H423.865V296.32H427.159V293.026Z",
    fill: "#F5F5F5"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 298.535H423.865V301.829H427.159V298.535Z",
    fill: "#F5F5F5"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 304.055H423.865V307.348H427.159V304.055Z",
    fill: "#F5F5F5"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 309.575H423.865V312.869H427.159V309.575Z",
    fill: "#F5F5F5"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 315.095H423.865V318.388H427.159V315.095Z",
    fill: "#F5F5F5"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 320.615H423.865V323.909H427.159V320.615Z",
    fill: "#F5F5F5"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M427.159 326.136H423.865V329.429H427.159V326.136Z",
    fill: "#F5F5F5"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M293.001 437.1C418.501 437.1 520.24 431.161 520.24 423.833C520.24 416.506 418.501 410.566 293.001 410.566C167.5 410.566 65.7617 416.506 65.7617 423.833C65.7617 431.161 167.5 437.1 293.001 437.1Z",
    fill: "#F5F5F5"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M491.361 415.289L475.937 338.453H470.018L454.595 415.289L443.25 422.228V424.29H502.33V422.228L491.361 415.289Z",
    fill: "#7F29D6"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M502.33 422.228H443.25V424.818H502.33V422.228Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M475.938 338.453H470.019L454.408 415.067H491.174L475.938 338.453Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M486.227 390.209L482.723 372.57H463.069L459.471 390.209H486.227Z",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M134.441 415.289L119.017 338.453H113.099L97.675 415.289L86.3418 422.228V424.29H145.411V422.228L134.441 415.289Z",
    fill: "#7F29D6"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.422 422.228H86.3418V424.818H145.422V422.228Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.018 338.453H113.099L97.4883 415.067H134.266L119.018 338.453Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M129.308 390.209L125.803 372.57H106.149L102.562 390.209H129.308Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M424.462 415.419L434.319 415.583C434.479 415.585 434.634 415.642 434.758 415.744C434.882 415.846 434.966 415.988 434.999 416.145L436.487 423.388C436.521 423.543 436.523 423.703 436.493 423.859C436.463 424.015 436.402 424.163 436.314 424.295C436.225 424.426 436.11 424.538 435.977 424.624C435.844 424.71 435.694 424.768 435.538 424.795C435.452 424.806 435.365 424.806 435.28 424.795C432.092 424.689 429.771 424.466 425.763 424.396C423.302 424.396 415.86 424.502 412.461 424.396C409.062 424.291 408.664 420.974 410.058 420.693C416.329 419.427 421.063 417.61 423.091 415.852C423.477 415.54 423.967 415.385 424.462 415.419Z",
    fill: "#263238"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M341.403 415.419L351.259 415.583C351.42 415.585 351.575 415.642 351.699 415.744C351.822 415.847 351.907 415.988 351.939 416.146L353.416 423.389C353.45 423.543 353.453 423.702 353.423 423.857C353.394 424.013 353.334 424.16 353.247 424.292C353.159 424.423 353.046 424.535 352.914 424.622C352.782 424.708 352.634 424.767 352.478 424.795C352.389 424.807 352.298 424.807 352.209 424.795C349.021 424.69 346.712 424.467 342.704 424.397C340.243 424.397 332.8 424.502 329.39 424.397C325.979 424.291 325.604 420.974 327.046 420.693C333.316 419.427 338.051 417.611 340.079 415.853C340.452 415.551 340.923 415.397 341.403 415.419Z",
    fill: "#263238"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M436.522 415.922H423.091C423.091 415.922 406.003 359.596 404.538 345.227C403.073 330.859 402.534 294.831 402.534 294.831V294.902C401.96 295.675 396.885 302.801 391.048 311.087C383.419 321.928 374.465 334.75 372.578 337.891C367.046 347.15 353.498 415.876 353.498 415.876H340.031C340.031 415.876 343.395 354.404 350.298 334.129C357.201 313.853 386.982 269.575 388.271 267.196C389.923 264.16 393.978 254.526 393.978 254.526L434.19 260.117C434.19 260.117 434.846 266.926 434.799 272.88C434.612 295.218 430.392 325.409 429.713 333.531C428.447 348.966 436.522 415.922 436.522 415.922Z",
    fill: "#7F29D6"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M403.472 189.622C403.472 189.622 391.436 211.081 393.991 254.527L434.19 260.117C435.362 253.988 435.632 223.34 445.641 195.083C441.331 193.608 436.93 192.41 432.467 191.497C426.822 190.384 421.116 189.601 415.38 189.153C411.404 188.999 407.423 189.156 403.472 189.622Z",
    fill: "#263238"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M393.978 254.526L434.189 260.117C434.904 256.284 435.291 242.83 437.928 226.363C438.631 221.968 439.498 217.351 440.588 212.663C441.943 206.713 443.629 200.844 445.64 195.083C441.331 193.602 436.931 192.404 432.466 191.496C426.817 190.385 421.107 189.602 415.367 189.152C411.411 189.013 407.45 189.173 403.518 189.633C403.518 189.633 391.446 211.08 393.978 254.526Z",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M428.13 170.178C427.31 175.78 426.712 185.988 430.767 189.504C425.564 192.024 421.802 193.723 417.5 197.989C415.731 194.661 413.539 190.336 413.539 190.336C419.645 188.566 419.27 183.984 417.981 179.718L428.13 170.178Z",
    fill: "#E4897B"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M423.993 174.068L417.992 179.776C418.302 180.767 418.529 181.783 418.672 182.811C421.016 182.354 424.133 179.6 424.262 177.116C424.364 176.092 424.273 175.058 423.993 174.068Z",
    fill: "black"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M436.522 415.922H423.091C423.091 415.922 406.003 359.596 404.538 345.227C403.073 330.859 402.534 294.831 402.534 294.831V294.902C401.96 295.675 396.885 302.801 391.048 311.087C383.419 321.928 374.465 334.75 372.578 337.891C367.046 347.15 353.498 415.876 353.498 415.876H340.031C340.031 415.876 343.395 354.404 350.298 334.129C357.201 313.853 386.982 269.575 388.271 267.196C389.923 264.16 393.978 254.526 393.978 254.526L434.19 260.117C434.19 260.117 434.846 266.926 434.799 272.88C434.612 295.218 430.392 325.409 429.713 333.531C428.447 348.966 436.522 415.922 436.522 415.922Z",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M437.436 192.645L434.096 188.473L423.279 190.559L417.782 196.853L417.091 189.586L415.063 187.148L410.621 189.071V193.618L413.786 192.598L416.516 198.939L425.166 195.388L427.088 197.837L437.436 192.645Z",
    fill: "#263238"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M437.436 192.645L434.096 188.473L423.279 190.559L417.782 196.853L417.091 189.586L415.063 187.148L410.621 189.071V193.618L413.786 192.598L416.516 198.939L425.166 195.388L427.088 197.837L437.436 192.645Z",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M408.383 200.38C397.232 200.321 386.095 199.562 375.04 198.106C365.394 195.528 356.745 182.32 351.998 174.092L356.499 170.951C362.359 177.022 368.148 183.925 375.555 187.898C376.093 188.157 376.672 188.316 377.266 188.367C387.557 188.812 398.269 188.836 408.629 189.305L408.348 200.38H408.383Z",
    fill: "#DC897C"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M412.825 205.092C406.965 209.405 384.17 202.982 384.17 202.982L387.006 189.012C393.448 188.297 399.956 188.415 406.368 189.363C416.06 191.075 419.306 200.298 412.825 205.092Z",
    fill: "#263238"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M412.825 205.092C406.965 209.405 384.17 202.982 384.17 202.982L387.006 189.012C393.448 188.297 399.956 188.415 406.368 189.363C416.06 191.075 419.306 200.298 412.825 205.092Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M412.064 205.56C412.544 202.302 410.434 199.454 404.094 197.895C397.928 196.616 391.598 196.328 385.342 197.04L384.17 202.982C384.17 202.982 405.325 209.076 412.064 205.56Z",
    fill: "black"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M359.804 175.464L355.386 165.572L347.475 170.764C347.475 170.764 349.584 178.101 355.866 178.675L359.804 175.464Z",
    fill: "#E4897B"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M349.325 160.837L344.344 166.111L347.485 170.764L355.396 165.572L349.325 160.837Z",
    fill: "#E4897B"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M416.516 198.938L415.473 191.344L410.621 193.617L413.786 192.598L416.516 198.938Z",
    fill: "black"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M416.516 198.939L424.532 193.044L427.087 197.837L425.165 195.388L416.516 198.939Z",
    fill: "black"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M437.929 226.363C438.633 221.968 439.5 217.35 440.59 212.662C439.292 211.053 437.449 209.977 435.41 209.639C435.41 209.639 434.308 220.28 437.929 226.363Z",
    fill: "black"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.535 294.855V294.926C401.961 295.699 396.886 302.825 391.049 311.111C390.474 306.619 391.24 302.057 393.253 298.001C395.266 293.944 398.434 290.574 402.359 288.315L402.535 294.855Z",
    fill: "black"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M429.327 201.4L416.927 204.588L412.544 187.547L382.951 195.188L378.556 200.486L393.511 143.175L361.257 151.496L353.053 157.801L331.148 236.513L337.313 260.41L385.693 247.928L390.627 267.043L421.099 259.168L429.303 252.862L425.377 237.626L428.542 236.818L436.746 230.512L429.327 201.4ZM378.099 214.608L374.677 215.499L376.517 208.467L378.099 214.608Z",
    fill: "#7F29D6"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M382.785 145.952L361.291 151.496L382.785 145.952Z",
    fill: "black"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M387.345 212.23L382.938 195.189L378.59 200.486L385.271 174.89L376.34 209.112L376.516 208.456L378.098 214.609L374.676 215.499L387.345 212.23Z",
    fill: "black"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.867 260.738L393.932 241.623L345.552 254.105L339.376 230.208L361.292 151.496L353.065 157.801L331.16 236.513L337.325 260.41L385.705 247.928L390.639 267.044L421.158 259.168L429.385 252.862L398.867 260.738Z",
    fill: "black"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M436.851 230.547L424.451 233.747L427.744 246.498L425.459 237.662L428.623 236.853L436.851 230.547L433.089 215.968L436.851 230.547Z",
    fill: "black"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M450.294 201.774C451.349 206.673 452.146 211.479 452.755 216.424C453.388 222.742 454.326 229.691 452.884 236.348C448.899 248.525 431.331 241.423 423.584 237.602L425.436 232.516C431.014 233.465 436.581 234.602 441.937 234.051C442.562 234.014 443.168 233.829 443.707 233.512C443.801 233.442 443.707 233.418 443.52 233.512C443.349 233.661 443.213 233.845 443.121 234.051C443.121 233.84 443.192 233.348 443.215 232.879C443.215 223.281 440.988 213.436 439.406 203.954L450.259 201.728L450.294 201.774Z",
    fill: "#DC897C"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M445.64 195.083C456.434 199.618 455.743 225.367 455.743 225.367L441.046 226.399C438.254 219.982 435.973 213.355 434.225 206.58C432.021 197.005 438.456 192.082 445.64 195.083Z",
    fill: "#263238"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.64 195.083C456.434 199.618 455.743 225.367 455.743 225.367L441.046 226.399C438.254 219.982 435.973 213.355 434.225 206.58C432.021 197.005 438.456 192.082 445.64 195.083Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M428.482 233.22L420.208 226.188L415.332 234.309C415.332 234.309 420.419 240.005 426.325 237.825L428.482 233.22Z",
    fill: "#E4897B"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M412.684 224.594L410.492 231.509L415.333 234.345L420.208 226.223L412.684 224.594Z",
    fill: "#E4897B"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M410.914 152.258C407.305 154.309 406.168 165.15 411.172 166.966C416.177 168.783 417.759 148.39 410.914 152.258Z",
    fill: "#263238"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M429.162 162.197C428.212 169.779 428.048 174.257 423.958 178.054C422.644 179.3 421.015 180.164 419.246 180.551C417.477 180.938 415.636 180.834 413.921 180.25C412.207 179.666 410.686 178.624 409.521 177.237C408.357 175.85 407.594 174.171 407.315 172.381C406.143 165.502 407.855 154.262 415.519 151.449C417.154 150.802 418.93 150.595 420.669 150.85C422.409 151.104 424.051 151.81 425.432 152.898C426.813 153.986 427.885 155.418 428.539 157.049C429.193 158.681 429.408 160.456 429.162 162.197Z",
    fill: "#E4897B"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M421.299 153.711L421.193 147.16C422.897 147.801 424.761 147.883 426.514 147.394C434.062 144.968 440.356 149.422 437.121 154.028C440.883 155.305 439.277 160.439 437.121 163.814C434.097 168.502 430.675 170.846 428.026 169.076C425.682 168.162 424.733 160.509 425.237 157.602C425.987 153.219 421.299 153.711 421.299 153.711Z",
    fill: "#263238"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M431.577 169.791C430.507 171.353 428.929 172.495 427.112 173.026C424.768 173.647 424.076 171.514 425.084 169.311C425.975 167.319 428.272 164.623 430.417 164.975C432.562 165.326 432.925 167.834 431.577 169.791Z",
    fill: "#E4897B"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M417.489 163.99C417.489 164.611 417.091 165.103 416.692 165.091C416.294 165.08 415.989 164.564 416.024 163.919C416.059 163.275 416.423 162.806 416.833 162.818C417.243 162.829 417.536 163.368 417.489 163.99Z",
    fill: "#263238"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M410.493 163.791C410.493 164.412 410.095 164.904 409.696 164.892C409.298 164.881 408.993 164.377 409.028 163.72C409.063 163.064 409.427 162.548 409.837 162.619C410.247 162.689 410.528 163.181 410.493 163.791Z",
    fill: "#263238"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M412.696 164.165C411.838 166.038 410.734 167.788 409.414 169.369C409.823 169.684 410.297 169.905 410.801 170.017C411.306 170.128 411.828 170.127 412.332 170.013L412.696 164.165Z",
    fill: "#DE5753"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M419.798 161.798C419.86 161.785 419.92 161.761 419.974 161.728C420.05 161.671 420.103 161.588 420.12 161.494C420.138 161.401 420.119 161.304 420.068 161.224C419.753 160.747 419.328 160.353 418.828 160.078C418.327 159.802 417.767 159.652 417.196 159.642C417.148 159.641 417.1 159.651 417.056 159.67C417.012 159.69 416.972 159.718 416.939 159.753C416.906 159.788 416.88 159.829 416.864 159.875C416.848 159.92 416.841 159.969 416.845 160.017C416.851 160.112 416.893 160.201 416.962 160.267C417.032 160.332 417.124 160.368 417.22 160.368C417.669 160.381 418.109 160.503 418.501 160.724C418.893 160.944 419.225 161.257 419.47 161.634C419.503 161.69 419.552 161.735 419.61 161.764C419.668 161.793 419.733 161.805 419.798 161.798Z",
    fill: "#263238"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M407.632 161.306C407.693 161.303 407.752 161.284 407.804 161.251C407.855 161.218 407.897 161.172 407.925 161.118C408.139 160.706 408.445 160.348 408.819 160.071C409.193 159.795 409.625 159.608 410.082 159.524C410.13 159.52 410.176 159.506 410.218 159.484C410.261 159.461 410.298 159.431 410.329 159.394C410.359 159.357 410.382 159.314 410.396 159.268C410.41 159.222 410.415 159.174 410.41 159.126C410.406 159.078 410.392 159.032 410.369 158.989C410.347 158.947 410.316 158.909 410.279 158.879C410.242 158.848 410.199 158.825 410.153 158.811C410.107 158.798 410.059 158.793 410.011 158.798C409.435 158.889 408.889 159.114 408.415 159.453C407.941 159.793 407.552 160.239 407.281 160.755C407.258 160.797 407.244 160.844 407.24 160.891C407.235 160.939 407.24 160.987 407.255 161.033C407.269 161.079 407.292 161.121 407.322 161.158C407.353 161.195 407.391 161.225 407.433 161.247C407.49 161.29 407.561 161.311 407.632 161.306Z",
    fill: "#263238"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M427.042 148.191C427.042 148.191 420.232 138.628 410.575 142.155C411.572 142.222 412.547 142.48 413.446 142.917C413.446 142.917 404.656 143.398 402.816 149.879L404.34 148.707C404.34 148.707 402.852 154.074 405.91 157.04L406.168 155.293C406.168 155.293 410.352 159.208 415.474 157.192L413.505 156.524C413.505 156.524 422.611 154.942 424.545 152.293C425.526 151.022 426.363 149.646 427.042 148.191Z",
    fill: "#263238"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M411.125 172.264C414.079 171.194 417.128 170.41 420.231 169.92C419.821 172.112 418.649 174.057 415.157 174.678C414.733 174.801 414.289 174.834 413.852 174.778C413.415 174.721 412.994 174.575 412.616 174.348C412.237 174.122 411.91 173.82 411.653 173.461C411.397 173.103 411.217 172.695 411.125 172.264Z",
    fill: "#263238"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M416.469 172.827C415.122 173.003 413.863 173.598 412.871 174.526C413.608 174.85 414.432 174.924 415.215 174.737C416.565 174.568 417.825 173.973 418.813 173.038C418.076 172.714 417.253 172.639 416.469 172.827Z",
    fill: "#A02724"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M411.371 172.147C411.486 172.384 411.663 172.586 411.884 172.731C412.105 172.876 412.361 172.957 412.625 172.967C414.64 172.584 416.619 172.036 418.544 171.326C418.859 171.238 419.147 171.074 419.382 170.846C419.618 170.619 419.793 170.337 419.892 170.025C417.002 170.518 414.154 171.227 411.371 172.147Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M291.443 424.817C297.385 424.817 298.182 424.724 301.522 424.606C304.382 424.513 305.038 424.864 307.382 424.817C309.304 424.817 309.234 422.931 308.636 420.821C308.343 419.754 307.886 417.504 307.464 415.793L298.744 415.16C297.514 417.504 294.748 420.833 291.396 421.29C288.044 421.747 289.075 424.817 291.443 424.817Z",
    fill: "#7F29D6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M296.787 404.8C300.111 401.591 303.052 398.008 305.554 394.123C307.183 391.779 307.487 392.389 309.222 390.115C309.455 389.755 309.599 389.346 309.645 388.92C309.69 388.495 309.635 388.064 309.483 387.664C309.331 387.263 309.087 386.904 308.771 386.615C308.455 386.327 308.076 386.116 307.663 386.001C306.141 385.697 304.651 385.253 303.21 384.677L297.268 389.048C298.358 391.849 296.928 399.737 293.869 402.983C291.677 405.316 295.053 406.394 296.787 404.8Z",
    fill: "#7F29D6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M276.84 260.644C276.84 260.644 259.74 309.516 257.525 327.448C255.369 344.899 297.689 390.396 297.689 390.396C298.721 391.169 302.963 385.895 303.198 384.536C292.65 364.19 286.122 334.046 275.55 326.662C300.901 289.076 304.44 265.039 304.44 265.039L276.84 260.644Z",
    fill: "#263238"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M321.633 178.229C327.552 187.136 326.872 191.508 324.985 209.076C323.098 226.644 329.356 234.028 326.321 242.115C323.285 250.201 301.521 249.522 291.829 233.325C282.137 217.128 294.337 182.319 303.549 178.92C309.375 176.899 315.67 176.658 321.633 178.229Z",
    fill: "#263238"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.852 277.837C288.852 277.837 287.457 295.804 287.141 308.028C290.493 302.062 293.212 296.624 295.415 291.76L288.852 277.837Z",
    fill: "black"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M285.125 261.945C285.125 261.945 291.489 311.169 295.134 334.867C298.955 359.737 299.447 399.655 298.486 415.923C299.88 416.731 304.932 416.169 307.674 415.313C307.674 415.313 324.188 361.952 312.058 337.317C319.91 279.76 308.542 265.661 308.542 265.661L285.125 261.945Z",
    fill: "#263238"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M289.32 227.652C284.328 233.501 278.385 238.466 271.74 242.337C259.305 249.58 256.504 228.742 256.118 220.69C256.108 220.106 256.309 219.537 256.683 219.089C257.058 218.64 257.581 218.341 258.158 218.245C258.735 218.15 259.326 218.265 259.825 218.57C260.324 218.875 260.697 219.348 260.876 219.905C262.048 223.421 263.29 227.007 264.697 230.254C265.599 232.176 266.572 234.508 267.978 235.563C267.978 235.246 266.712 235.164 266.49 235.317H266.302L267.931 234.145C272.969 230.301 277.649 226.01 281.913 221.323C286.226 216.858 293.036 222.741 289.285 227.652H289.32Z",
    fill: "#E9B376"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M320.872 227.406C311.988 246.603 309.328 256.612 308.554 265.66L276.84 260.644C277.566 250.166 278.106 243.896 278.867 237.555C279.274 233.215 279.975 228.908 280.965 224.663C281.821 220.151 285.384 215.486 289.767 213.951C290.776 213.58 291.845 213.397 292.92 213.412C294.502 213.412 296.154 213.506 297.748 213.611C302.597 214.034 307.409 214.794 312.152 215.885C313.512 216.178 314.824 216.494 316.067 216.822C316.325 216.893 316.594 216.987 316.84 217.08C317.814 217.455 318.699 218.028 319.438 218.764C320.178 219.5 320.756 220.381 321.135 221.353C321.514 222.325 321.687 223.365 321.642 224.407C321.596 225.449 321.334 226.471 320.872 227.406Z",
    fill: "#7F29D6"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M313.711 199.478C311.719 203.919 308.835 212.17 311.367 215.733C311.367 215.733 307.089 214.385 296.858 218.663C294.771 214.374 296.963 213.46 296.963 213.46C302.425 213.049 303.175 209.24 303.116 205.549L313.711 199.478Z",
    fill: "#EBB376"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M309.409 201.95L303.115 205.56C303.136 206.43 303.085 207.3 302.963 208.162C305.002 208.162 308.213 206.474 308.905 204.47C309.23 203.669 309.401 202.814 309.409 201.95Z",
    fill: "black"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M320.872 227.406C319.88 229.539 318.965 231.566 318.129 233.488C315.715 239.008 313.887 243.685 312.504 247.775C310.448 253.549 309.121 259.557 308.554 265.66L276.84 260.644C277.566 250.166 278.106 243.896 278.867 237.555C279.274 233.215 279.975 228.908 280.965 224.663C281.821 220.151 285.384 215.486 289.767 213.951C290.776 213.58 291.845 213.397 292.92 213.412C294.502 213.412 296.154 213.506 297.748 213.611C302.597 214.034 307.409 214.794 312.152 215.885C313.512 216.178 314.824 216.494 316.067 216.822C316.325 216.893 316.594 216.987 316.84 217.08C317.814 217.455 318.699 218.028 319.438 218.764C320.178 219.5 320.756 220.381 321.135 221.353C321.514 222.325 321.687 223.365 321.642 224.407C321.596 225.449 321.334 226.471 320.872 227.406Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M319.137 190.805C316.547 198.071 315.621 201.189 310.769 204.095C303.491 208.478 295.111 204.224 295.474 196.465C295.802 189.433 299.987 178.78 308.097 177.526C309.828 177.2 311.614 177.343 313.271 177.94C314.928 178.536 316.395 179.565 317.521 180.919C318.647 182.273 319.391 183.904 319.675 185.642C319.959 187.38 319.773 189.163 319.137 190.805Z",
    fill: "#EBB376"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M310.582 174.08C304.945 174.08 296.694 179.272 303.855 180.807C303.784 183.151 308.003 183.304 311.109 182.214C310.605 183.89 313.313 187.347 317.204 186.48C314.93 187.593 314.532 193.359 317.204 193.817C319.876 194.274 325.408 195.996 324.927 186.48C324.447 176.963 316.618 174.08 310.582 174.08Z",
    fill: "#263238"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M309.41 190.546C309.21 191.156 308.73 191.589 308.331 191.496C307.933 191.402 307.769 190.816 307.956 190.195C308.144 189.574 308.624 189.152 309.023 189.245C309.421 189.339 309.574 189.925 309.41 190.546Z",
    fill: "#263238"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M301.638 188.472C301.439 189.093 300.97 189.515 300.56 189.421C300.15 189.328 299.997 188.753 300.185 188.132C300.372 187.511 300.853 187.089 301.251 187.183C301.65 187.277 301.826 187.851 301.638 188.472Z",
    fill: "#263238"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M301.428 187.253L300.08 186.479C300.08 186.479 300.479 187.816 301.428 187.253Z",
    fill: "#263238"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M303.549 190.395C302.565 191.677 301.423 192.831 300.15 193.829C300.4 194.128 300.714 194.367 301.07 194.527C301.425 194.687 301.812 194.765 302.201 194.754L303.549 190.395Z",
    fill: "#D58745"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M305.072 197.872C304.717 197.848 304.364 197.797 304.017 197.719C303.992 197.714 303.969 197.704 303.948 197.689C303.928 197.674 303.911 197.654 303.899 197.632C303.886 197.61 303.879 197.585 303.877 197.56C303.876 197.534 303.879 197.509 303.888 197.485C303.904 197.438 303.937 197.399 303.981 197.375C304.024 197.352 304.075 197.345 304.123 197.356C304.907 197.546 305.723 197.556 306.511 197.383C307.299 197.21 308.038 196.86 308.67 196.36C308.688 196.342 308.709 196.327 308.732 196.318C308.755 196.308 308.78 196.303 308.805 196.303C308.83 196.303 308.855 196.308 308.878 196.318C308.901 196.327 308.922 196.342 308.94 196.36C308.957 196.376 308.972 196.396 308.981 196.418C308.991 196.441 308.996 196.465 308.996 196.489C308.996 196.513 308.991 196.537 308.981 196.559C308.972 196.581 308.957 196.601 308.94 196.618C307.852 197.503 306.472 197.951 305.072 197.872Z",
    fill: "#263238"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M319.828 197.45C318.688 198.624 317.128 199.298 315.492 199.325C313.394 199.325 313.066 197.157 314.238 195.364C315.41 193.57 317.672 191.789 319.488 192.668C321.305 193.547 321.282 195.961 319.828 197.45Z",
    fill: "#EBB376"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M311.752 186.937C311.703 186.929 311.656 186.911 311.614 186.885C311.572 186.859 311.535 186.825 311.506 186.784C311.267 186.393 310.934 186.068 310.537 185.838C310.139 185.609 309.691 185.483 309.232 185.472C309.136 185.472 309.044 185.433 308.976 185.365C308.907 185.297 308.869 185.205 308.869 185.108C308.877 185.009 308.92 184.915 308.991 184.844C309.062 184.773 309.156 184.73 309.256 184.722C309.837 184.726 310.407 184.878 310.913 185.163C311.42 185.448 311.845 185.857 312.151 186.351C312.203 186.435 312.22 186.536 312.198 186.633C312.177 186.729 312.117 186.813 312.034 186.866C311.951 186.922 311.851 186.947 311.752 186.937Z",
    fill: "#263238"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M299.694 183.643C299.647 183.645 299.601 183.636 299.559 183.618C299.516 183.6 299.478 183.572 299.447 183.538C299.412 183.504 299.383 183.463 299.364 183.418C299.344 183.372 299.334 183.324 299.334 183.274C299.334 183.225 299.344 183.176 299.364 183.131C299.383 183.085 299.412 183.044 299.447 183.01C299.87 182.569 300.39 182.233 300.966 182.03C301.542 181.826 302.158 181.761 302.764 181.838C302.811 181.848 302.855 181.867 302.894 181.894C302.933 181.922 302.965 181.957 302.989 181.998C303.014 182.039 303.029 182.084 303.035 182.132C303.04 182.179 303.036 182.227 303.022 182.272C302.997 182.37 302.936 182.454 302.851 182.509C302.766 182.563 302.664 182.583 302.565 182.565C302.085 182.512 301.599 182.569 301.144 182.732C300.69 182.894 300.278 183.158 299.94 183.503C299.876 183.577 299.789 183.626 299.694 183.643Z",
    fill: "#263238"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M309.162 189.328L307.826 188.555C307.826 188.555 308.236 189.891 309.162 189.328Z",
    fill: "#263238"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76 214.186C288.572 211.842 283.661 214.737 276.148 223.222C276.676 227.57 283.989 234.122 283.989 234.122C283.989 234.122 296.518 222.226 294.76 214.186Z",
    fill: "#7F29D6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M316.839 217.045C314.282 218.357 311.657 219.531 308.975 220.561C308.283 220.807 307.58 221.065 306.865 221.299C302.786 222.671 298.52 223.526 295.473 222.624C294.144 222.333 292.924 221.673 291.953 220.719C290.983 219.766 290.302 218.557 289.988 217.233C289.729 216.131 289.657 214.994 289.777 213.869C290.786 213.498 291.855 213.315 292.93 213.33H293.997C294.465 213.33 294.911 213.33 295.379 213.33L297.723 213.459C302.572 213.882 307.385 214.641 312.127 215.732L312.432 215.803L313.499 216.037C314.366 216.236 315.221 216.447 316.042 216.67C316.323 216.858 316.593 216.951 316.839 217.045Z",
    fill: "#EBB376"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M313.522 216.108C311.833 217.405 310.306 218.9 308.975 220.562C308.283 220.808 307.58 221.066 306.865 221.3C308.393 219.171 310.291 217.333 312.467 215.874L313.522 216.108Z",
    fill: "#263238"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M295.344 213.447C293.498 214.97 291.844 216.714 290.422 218.639C290.222 218.202 290.065 217.747 289.953 217.28C291.12 215.826 292.466 214.526 293.961 213.412C294.454 213.412 294.899 213.436 295.344 213.447Z",
    fill: "#263238"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M313.522 216.108C311.833 217.405 310.306 218.9 308.975 220.562C308.283 220.808 307.58 221.066 306.865 221.3C308.393 219.171 310.291 217.333 312.467 215.874L313.522 216.108Z",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M295.344 213.447C293.498 214.97 291.844 216.714 290.422 218.639C290.222 218.202 290.065 217.747 289.953 217.28C291.12 215.826 292.466 214.526 293.961 213.412C294.454 213.412 294.899 213.436 295.344 213.447Z",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M318.128 233.489C315.714 239.009 313.886 243.685 312.503 247.775C300.935 240.615 310.487 228.555 310.487 228.555C313.405 229.538 316.031 231.234 318.128 233.489Z",
    fill: "black"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M260.279 181.616C233.135 180.058 212.508 200.966 210.34 239.044C210.132 242.506 210.104 245.976 210.258 249.44C209.086 285.901 226.97 307.946 253.446 309.458C280.589 311.005 301.217 290.097 303.385 252.03C303.593 248.569 303.62 245.099 303.467 241.635C304.627 205.174 286.754 183.128 260.279 181.616ZM268.576 242.396C267.322 264.571 261.931 271.181 255.18 270.806C249.707 270.489 245.652 265.696 244.996 252.054C244.996 250.975 245.078 249.862 245.136 248.702C246.402 226.528 251.782 219.917 258.532 220.304C264.017 220.609 268.072 225.402 268.729 239.056C268.694 240.134 268.647 241.236 268.576 242.396Z",
    fill: "#7F29D6"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M303.361 232.938C303.361 232.387 303.361 231.836 303.256 231.285C303.303 231.836 303.326 232.387 303.361 232.938Z",
    fill: "black"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.21 248.186C210.21 247.67 210.21 247.154 210.21 246.639C210.175 247.154 210.198 247.67 210.21 248.186Z",
    fill: "black"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.34 239.255C212.508 201.142 233.135 180.234 260.279 181.827C283.133 183.128 299.588 199.724 302.916 227.7C299.635 199.572 283.18 182.953 260.279 181.652C233.135 180.093 212.508 201.001 210.34 239.08C210.27 240.252 210.223 241.424 210.199 242.596C210.223 241.517 210.27 240.392 210.34 239.255Z",
    fill: "black"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M303.479 235.552C303.479 235.282 303.479 235.024 303.479 234.755C303.468 235.013 303.468 235.282 303.479 235.552Z",
    fill: "black"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.164 245.561C210.164 244.729 210.164 243.897 210.164 243.053C210.176 243.897 210.164 244.729 210.164 245.561Z",
    fill: "black"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M303.362 244.552C301.182 282.665 280.555 303.562 253.411 301.98C228.799 300.585 211.653 281.482 210.247 249.568C209.133 285.9 226.994 307.946 253.446 309.457C280.59 311.004 301.217 290.096 303.385 252.029C303.593 248.603 303.621 245.168 303.467 241.739C303.444 242.669 303.409 243.607 303.362 244.552Z",
    fill: "black"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.112 241.236C243.847 263.41 248.441 270.594 255.192 270.969C261.942 271.344 267.322 264.746 268.587 242.572C269.853 220.397 265.247 213.272 258.508 212.826C251.769 212.381 246.366 219.061 245.112 241.236ZM268.728 239.044C268.728 240.134 268.646 241.236 268.576 242.396C267.322 264.57 261.931 271.18 255.18 270.805C249.707 270.489 245.651 265.695 244.995 252.053C244.995 250.975 245.077 249.861 245.136 248.701C246.402 226.527 251.781 219.917 258.532 220.304C264.017 220.608 268.072 225.402 268.728 239.044Z",
    fill: "black"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M251.289 217.28L251.618 219.343C251.677 219.728 251.829 220.093 252.059 220.407C252.29 220.721 252.592 220.975 252.942 221.148L256.235 222.788C256.883 223.113 257.6 223.275 258.324 223.263C259.049 223.251 259.759 223.064 260.396 222.718L261.205 222.296C260.888 218.78 258.005 215.264 258.005 215.264L257.29 214.163C257.149 213.934 256.964 213.737 256.746 213.58C256.528 213.424 256.281 213.312 256.02 213.251C255.759 213.19 255.488 213.181 255.223 213.225C254.958 213.269 254.705 213.364 254.477 213.506L252.297 214.936C251.921 215.188 251.625 215.543 251.446 215.959C251.268 216.375 251.213 216.834 251.289 217.28Z",
    fill: "#EBB376"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M276.734 238.822L279.078 238.306C279.512 238.209 279.963 238.216 280.393 238.328C280.823 238.441 281.22 238.654 281.551 238.951L284.68 241.775C285.298 242.328 285.774 243.021 286.068 243.796C286.361 244.571 286.464 245.405 286.368 246.229L286.251 247.272C282.43 248.444 277.473 246.803 277.473 246.803L276.008 246.498C275.4 246.387 274.86 246.04 274.507 245.533C274.154 245.026 274.015 244.4 274.121 243.791L274.671 240.884C274.781 240.379 275.034 239.916 275.4 239.55C275.765 239.184 276.229 238.931 276.734 238.822Z",
    fill: "#EBB376"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M321.351 233.126C319.269 242.191 315.273 250.706 309.631 258.101C302.013 266.188 286.519 251.28 281.034 245.772C280.638 245.341 280.41 244.782 280.394 244.197C280.377 243.613 280.572 243.041 280.943 242.589C281.314 242.137 281.836 241.834 282.413 241.736C282.989 241.638 283.582 241.752 284.082 242.056C287.785 244.4 291.665 246.815 295.532 248.842C298.122 250.155 300.853 251.596 303.49 251.889C304.346 251.889 303.795 251.678 303.256 252.136L302.623 252.815C303.683 251.194 304.654 249.516 305.529 247.787C308.177 242.311 310.304 236.598 311.881 230.723C312.296 229.591 313.116 228.653 314.183 228.091C315.251 227.529 316.488 227.384 317.656 227.683C318.824 227.983 319.84 228.705 320.505 229.711C321.17 230.717 321.439 231.934 321.257 233.126H321.351Z",
    fill: "#E9B376"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M318.515 217.913C323.918 221.746 324.176 227.465 321.257 238.423C317.343 240.38 307.85 237.907 307.85 237.907C307.85 237.907 310.838 220.89 318.515 217.913Z",
    fill: "#7F29D6"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M318.515 217.913C323.918 221.746 324.176 227.465 321.257 238.423C317.343 240.38 307.85 237.907 307.85 237.907C307.85 237.907 310.838 220.89 318.515 217.913Z",
    fill: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M216.01 407.261L223.288 404.624L219.28 387.079L212.002 389.716L216.01 407.261Z",
    fill: "#FFC3BD"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M158.594 416.931H166.317L168.521 399.034H160.785L158.594 416.931Z",
    fill: "#FFC3BD"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M167.339 416.04H157.963C157.809 416.039 157.66 416.091 157.541 416.187C157.421 416.283 157.339 416.417 157.306 416.567L155.712 423.435C155.683 423.605 155.692 423.779 155.737 423.945C155.783 424.111 155.864 424.265 155.976 424.396C156.088 424.527 156.228 424.632 156.385 424.703C156.542 424.774 156.712 424.809 156.884 424.807C159.92 424.748 162.123 424.572 165.944 424.572C168.288 424.572 175.379 424.818 178.613 424.818C181.848 424.818 182.317 421.619 180.957 421.302C175.015 420.001 170.55 418.196 168.663 416.485C168.295 416.173 167.821 416.013 167.339 416.04Z",
    fill: "#263238"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M223.56 403.136L215.285 404.917C215.136 404.949 215.002 405.03 214.904 405.146C214.806 405.263 214.751 405.41 214.746 405.562L214.629 412.594C214.637 412.759 214.679 412.921 214.754 413.068C214.828 413.216 214.933 413.346 215.062 413.45C215.19 413.554 215.339 413.629 215.499 413.672C215.658 413.714 215.825 413.722 215.988 413.696C218.965 413.004 223.243 411.914 226.993 411.106C231.377 410.168 234.096 409.277 239.229 408.176C242.335 407.508 242.558 404.191 241.198 404.191C235.01 404.191 231.26 405.363 225.505 403.324C224.886 403.082 224.213 403.017 223.56 403.136Z",
    fill: "#263238"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.28 387.079L221.343 396.127L214.065 398.764L212.002 389.728L219.28 387.079Z",
    fill: "black"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.787 399.046H168.522L167.386 408.27H159.65L160.787 399.046Z",
    fill: "black"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M223.477 393.455L211.159 397.92C211.159 397.92 201.584 355.576 196.404 332.019C194.135 322.716 191.333 313.551 188.012 304.57C183.324 291.374 177.757 277.169 173.245 266.07C168.487 254.35 164.947 246.146 164.947 246.146L191.599 240.755C191.599 240.755 211.933 299.261 216.504 322.396C221.25 346.411 223.477 393.455 223.477 393.455Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.477 393.455L211.159 397.92C211.159 397.92 201.584 355.576 196.404 332.019C194.135 322.716 191.333 313.551 188.012 304.57C183.324 291.374 177.757 277.169 173.245 266.07C168.487 254.35 164.947 246.146 164.947 246.146L191.599 240.755C191.599 240.755 211.933 299.261 216.504 322.396C221.25 346.411 223.477 393.455 223.477 393.455Z",
    fill: "white"
  }))), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.011 304.571C183.323 291.374 177.756 277.17 173.244 266.071L175.307 259.695C182.937 266.751 187.695 291.117 188.011 304.571Z",
    fill: "black"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M177.218 243.639C177.218 243.639 181.976 310.361 182.269 333.027C182.585 357.85 170.971 406.476 170.971 406.476H156.825C156.825 406.476 162.474 362.608 160.564 337.996C158.454 310.501 151.035 248.924 151.035 248.924L177.218 243.639Z",
    fill: "#263238"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.218 243.639C177.218 243.639 181.976 310.361 182.269 333.027C182.585 357.85 170.971 406.476 170.971 406.476H156.825C156.825 406.476 162.474 362.608 160.564 337.996C158.454 310.501 151.035 248.924 151.035 248.924L177.218 243.639Z",
    fill: "white"
  }))), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M172.658 406.781H156.004L156.051 401.8L173.443 400.804L172.658 406.781Z",
    fill: "#263238"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M225.129 393.292L210.362 398.425L208.756 393.655L224.906 387.783L225.129 393.292Z",
    fill: "#263238"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M167.866 417.106C167.831 417.1 167.799 417.083 167.774 417.058C167.749 417.033 167.732 417.001 167.725 416.966C167.719 416.93 167.724 416.893 167.738 416.86C167.753 416.826 167.777 416.798 167.807 416.778C168.089 416.602 170.608 415.067 171.452 415.512C171.547 415.56 171.627 415.634 171.681 415.725C171.735 415.817 171.761 415.922 171.757 416.028C171.777 416.208 171.752 416.39 171.685 416.557C171.617 416.725 171.509 416.873 171.37 416.989C170.933 417.286 170.409 417.426 169.882 417.388C169.201 417.37 168.525 417.276 167.866 417.106ZM168.393 416.848C169.291 417.161 170.275 417.11 171.136 416.708C171.229 416.628 171.302 416.526 171.347 416.412C171.392 416.297 171.408 416.174 171.394 416.051C171.394 415.899 171.335 415.852 171.276 415.829C171.199 415.814 171.119 415.814 171.042 415.829C170.103 415.998 169.204 416.344 168.393 416.848Z",
    fill: "#7F29D6"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M167.807 417.083C167.778 417.068 167.754 417.044 167.739 417.014C167.724 416.985 167.719 416.951 167.725 416.919C167.725 416.825 167.936 414.575 168.897 413.86C169.003 413.769 169.126 413.702 169.259 413.661C169.393 413.621 169.533 413.609 169.671 413.625C169.809 413.623 169.945 413.67 170.052 413.758C170.159 413.846 170.232 413.969 170.257 414.106C170.409 414.961 168.839 416.661 168.042 417.094H167.948C167.926 417.106 167.901 417.111 167.876 417.109C167.851 417.107 167.827 417.098 167.807 417.083ZM169.073 414.141C168.527 414.839 168.2 415.683 168.135 416.567C168.932 415.958 169.94 414.68 169.847 414.223C169.847 414.223 169.847 414.059 169.577 414.035H169.495C169.342 414.032 169.193 414.081 169.073 414.176V414.141Z",
    fill: "#7F29D6"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M238.256 146.432L244.444 139.775L248.148 149.151C248.148 149.151 242.288 154.754 239.51 151.613L238.256 146.432Z",
    fill: "#FFC3BD"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M253.116 137.326L253.562 146.468L248.147 149.152L244.443 139.776L253.116 137.326Z",
    fill: "#FFC3BD"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M224.367 403.909C224.355 403.872 224.354 403.832 224.365 403.795C224.375 403.757 224.396 403.724 224.426 403.698C224.73 403.452 227.449 401.249 228.481 401.565C228.577 401.596 228.665 401.651 228.735 401.725C228.804 401.798 228.854 401.889 228.879 401.987C228.93 402.145 228.942 402.313 228.913 402.476C228.885 402.64 228.817 402.794 228.715 402.925C228.035 403.839 225.809 404.003 224.543 404.026C224.505 404.025 224.469 404.014 224.438 403.993C224.407 403.972 224.382 403.943 224.367 403.909ZM225.082 403.64C226.816 403.558 228.047 403.218 228.422 402.714C228.491 402.626 228.537 402.521 228.556 402.411C228.574 402.3 228.565 402.187 228.528 402.081C228.528 401.999 228.457 401.94 228.375 401.917H228.305C227.684 401.835 226.195 402.808 225.082 403.628V403.64Z",
    fill: "#7F29D6"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M136.021 183.503C129.353 186.128 108.268 203.427 107.483 210.963C106.698 218.499 131.322 226.937 131.322 226.937L137.299 221.863C137.299 221.863 122.309 210.342 122.309 208.971C122.309 207.599 141.061 197.696 141.061 197.696C142.41 194.474 142.58 190.881 141.542 187.546C140.299 184.066 136.021 183.503 136.021 183.503Z",
    fill: "#263238"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M178.543 175.276C188.517 174.514 206.589 168.818 211.441 165.712C216.293 162.606 238.256 145.601 238.256 145.601L244.515 152.808C244.515 152.808 227.978 172.017 218.496 178.229C209.015 184.441 183.219 194.227 183.219 194.227L178.543 175.276Z",
    fill: "#263238"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M224.462 404.003C224.434 403.99 224.41 403.97 224.391 403.946C224.373 403.921 224.361 403.893 224.356 403.862C224.212 402.774 224.413 401.667 224.93 400.698C225.043 400.552 225.184 400.431 225.345 400.342C225.507 400.254 225.685 400.199 225.868 400.182C226.372 400.124 226.559 400.346 226.641 400.534C226.946 401.366 225.469 403.382 224.649 403.991H224.52L224.462 404.003ZM225.903 400.546C225.768 400.556 225.637 400.596 225.52 400.663C225.402 400.73 225.301 400.822 225.223 400.932C224.79 401.706 224.605 402.594 224.696 403.476C225.516 402.714 226.477 401.132 226.29 400.675C226.29 400.675 226.29 400.557 226.091 400.546H225.903Z",
    fill: "#7F29D6"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M136.021 183.503C137.193 186.363 138.295 189.258 139.28 192.153C140.366 195.341 141.35 198.513 142.233 201.669C142.843 203.826 143.405 205.982 143.921 208.092C144.108 208.807 144.272 209.534 144.436 210.237C144.847 211.936 145.21 213.612 145.608 215.265C146.007 216.917 146.253 218.394 146.546 219.953C146.839 221.511 147.167 223.176 147.437 224.723C147.706 226.27 147.952 227.758 148.187 229.2C148.421 230.641 148.679 232.352 148.89 233.888C149.16 235.74 149.394 237.474 149.605 239.068C150.261 243.862 150.707 247.366 151.105 249.042L191.645 240.838C191.645 237.662 191.645 234.603 191.492 231.649C191.422 229.68 191.328 227.77 191.188 225.906C191.117 224.676 191.023 223.469 190.918 222.273C190.766 220.468 190.59 218.757 190.402 216.999C190.168 215.089 189.922 213.249 189.652 211.467C189.16 208.186 188.613 205.135 188.011 202.314C187.273 198.892 186.488 195.798 185.667 193.032C184.659 189.516 183.628 186.609 182.691 184.16C181.569 181.121 180.189 178.184 178.565 175.382C175.258 175.197 171.942 175.221 168.638 175.452C167.935 175.452 167.232 175.569 166.517 175.651C160.706 176.485 154.95 177.659 149.277 179.167C148.21 179.437 147.109 179.753 146.054 180.07C142.654 181.044 139.305 182.19 136.021 183.503Z",
    fill: "#263238"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M146.5 159.22C148.844 164.564 152.09 174.456 148.739 178.991C150.963 180.449 153.462 181.437 156.082 181.894C158.702 182.352 161.388 182.269 163.975 181.652C169.026 180.609 168.58 177.21 167.069 175.581C160.201 175.323 159.404 170.694 159.65 166.205L146.5 159.22Z",
    fill: "#FFC3BD"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.551 162.196L159.614 166.122C159.538 167.177 159.561 168.237 159.685 169.287C151.75 171.42 148.457 162.853 148.551 162.196Z",
    fill: "black"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M173.62 289.839L186.945 262.883L184.719 253.882L179.691 251.409L184.379 241.974L182.14 232.973L163.259 223.656L199.591 196.266L197.364 187.277L170.303 173.916L105.843 220.984L94.9316 243.064L97.1702 252.065L132.33 269.422L126.728 280.767L128.955 289.768L154.516 302.391L163.259 284.682L173.62 289.839ZM149.547 236.477L147.496 235.469L151.551 232.411L149.547 236.477Z",
    fill: "#7F29D6"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M179.691 251.362L184.344 241.927L182.129 232.926L163.237 223.609L199.545 196.219L197.318 187.218L170.304 173.893L105.844 220.96L105.773 221.089L170.222 174.033L197.236 187.371L138.847 231.391L149.454 236.63L149.536 236.477L147.497 235.469L151.528 232.434L157.248 220.843L182.035 233.079L174.242 248.865L184.626 253.987L171.3 280.99L160.916 275.857L152.173 293.566L126.752 281.013L128.932 289.792L154.493 302.414L163.237 284.705L173.621 289.827L186.946 262.836L184.719 253.835L179.691 251.362Z",
    fill: "black"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.354 263.246L94.9668 243.311L97.1467 252.089L132.295 269.434L135.354 263.246Z",
    fill: "black"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M135.705 221.862L144.319 224.769L137.287 232C137.287 232 129.751 228.953 131.427 225.144L135.705 221.862Z",
    fill: "#FFC3BD"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M150.121 231.649L141.963 235.821L137.299 232.001L144.319 224.758L150.121 231.649Z",
    fill: "#FFC3BD"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M157.47 134.408C164.244 134.69 166.846 148.847 164.76 151.156C160.787 155.457 149.078 134.068 157.47 134.408Z",
    fill: "#263238"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M142.784 152.703C146.148 160.227 147.742 164.798 153.11 167.294C161.197 171.045 169.377 163.942 168.346 155.574C167.396 148.038 162.052 136.998 153.356 136.764C151.44 136.702 149.541 137.13 147.837 138.009C146.134 138.888 144.684 140.188 143.625 141.785C142.565 143.382 141.932 145.224 141.785 147.135C141.638 149.046 141.982 150.962 142.784 152.703Z",
    fill: "#FFC3BD"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M134.779 150.183C137.264 155.129 145.667 163.614 148.55 162.243C151.668 160.743 149.992 153.394 146.007 147.651L134.779 150.183Z",
    fill: "#263238"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M142.491 162.501C143.309 163.122 144.242 163.576 145.235 163.835C146.229 164.094 147.264 164.155 148.281 164.013C151 163.626 151.258 160.931 149.582 158.938C148.058 157.145 144.824 155.2 142.55 156.594C142.053 156.908 141.643 157.342 141.357 157.855C141.071 158.368 140.918 158.944 140.912 159.532C140.906 160.119 141.048 160.699 141.324 161.218C141.6 161.736 142.001 162.178 142.491 162.501Z",
    fill: "#FFC3BD"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M155.278 150.476C155.512 151.109 156.028 151.484 156.45 151.332C156.872 151.18 157.001 150.547 156.766 149.914C156.532 149.281 156.016 148.906 155.594 149.058C155.173 149.211 155.044 149.844 155.278 150.476Z",
    fill: "#263238"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M162.357 147.804C162.604 148.425 163.119 148.811 163.529 148.659C163.94 148.507 164.08 147.874 163.846 147.241C163.612 146.608 163.084 146.233 162.674 146.385C162.264 146.538 162.123 147.171 162.357 147.804Z",
    fill: "#263238"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M160.225 148.964C161.694 150.599 163.382 152.022 165.241 153.195C164.926 153.662 164.514 154.054 164.032 154.346C163.55 154.637 163.011 154.82 162.451 154.882L160.225 148.964Z",
    fill: "#ED847E"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M161.302 157.297C161.343 157.273 161.375 157.236 161.392 157.191C161.409 157.146 161.41 157.097 161.396 157.051C161.386 157.027 161.373 157.004 161.355 156.985C161.337 156.965 161.315 156.95 161.291 156.939C161.267 156.928 161.241 156.922 161.215 156.921C161.189 156.92 161.162 156.925 161.138 156.934C160.364 157.246 159.527 157.371 158.696 157.297C157.865 157.224 157.063 156.955 156.356 156.512C156.339 156.494 156.318 156.48 156.294 156.47C156.271 156.46 156.246 156.455 156.221 156.455C156.196 156.455 156.171 156.46 156.148 156.47C156.125 156.48 156.104 156.494 156.086 156.512C156.068 156.53 156.054 156.551 156.044 156.574C156.034 156.597 156.029 156.622 156.029 156.647C156.029 156.672 156.034 156.697 156.044 156.72C156.054 156.743 156.068 156.764 156.086 156.782C156.845 157.269 157.709 157.567 158.606 157.651C159.504 157.734 160.408 157.601 161.243 157.262L161.302 157.297Z",
    fill: "#263238"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M152.359 148.964C152.406 148.94 152.448 148.907 152.482 148.867C152.516 148.827 152.542 148.78 152.558 148.73C152.685 148.252 152.924 147.81 153.253 147.442C153.583 147.073 153.996 146.788 154.457 146.608C154.556 146.576 154.638 146.507 154.686 146.415C154.734 146.323 154.744 146.216 154.715 146.116C154.7 146.066 154.676 146.02 154.643 145.98C154.61 145.94 154.569 145.907 154.523 145.883C154.477 145.859 154.427 145.844 154.375 145.84C154.324 145.836 154.272 145.842 154.223 145.858C153.637 146.075 153.111 146.428 152.689 146.889C152.267 147.35 151.961 147.904 151.796 148.507C151.782 148.556 151.778 148.608 151.784 148.659C151.79 148.71 151.806 148.759 151.831 148.804C151.856 148.848 151.89 148.888 151.93 148.919C151.97 148.951 152.017 148.974 152.066 148.988C152.114 149.004 152.165 149.011 152.215 149.007C152.265 149.003 152.315 148.988 152.359 148.964Z",
    fill: "#263238"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M164.595 144.183L164.701 144.101C164.737 144.065 164.766 144.022 164.786 143.975C164.806 143.927 164.816 143.877 164.816 143.825C164.816 143.774 164.806 143.723 164.786 143.676C164.766 143.629 164.737 143.586 164.701 143.55C164.26 143.107 163.718 142.778 163.122 142.59C162.526 142.402 161.894 142.362 161.278 142.472C161.228 142.483 161.181 142.504 161.139 142.533C161.096 142.563 161.061 142.601 161.033 142.644C161.006 142.688 160.988 142.737 160.98 142.788C160.971 142.838 160.973 142.89 160.985 142.94C161.013 143.041 161.078 143.128 161.168 143.182C161.257 143.237 161.364 143.255 161.466 143.233C161.954 143.158 162.452 143.199 162.921 143.354C163.39 143.509 163.815 143.773 164.162 144.124C164.221 144.174 164.293 144.206 164.37 144.216C164.447 144.226 164.525 144.215 164.595 144.183Z",
    fill: "#263238"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M140.406 157.508C138.502 156.295 136.868 154.702 135.608 152.828C134.347 150.955 133.487 148.842 133.081 146.62C131.769 139.12 145.293 131.63 152.829 131.044C160.365 130.458 159.17 138.709 159.17 138.709C159.17 138.709 149.407 142.225 146.043 144.323C142.68 146.421 146.043 147.663 146.043 147.663L140.406 157.508Z",
    fill: "#263238"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M122.31 209.076C122.31 208.994 122.381 208.889 122.51 208.748H108.188C107.83 209.462 107.592 210.23 107.485 211.022C106.711 218.523 131.323 226.996 131.323 226.996L137.3 221.921C137.3 221.921 122.31 210.342 122.31 209.076Z",
    fill: "#263238"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M307.966 132.954L248.604 144.252C246.75 144.606 244.845 144.591 242.997 144.208C241.149 143.825 239.394 143.081 237.833 142.02C236.273 140.959 234.936 139.601 233.901 138.023C232.865 136.445 232.15 134.679 231.797 132.825C231.442 130.971 231.456 129.065 231.839 127.217C232.221 125.368 232.964 123.613 234.025 122.052C235.087 120.491 236.446 119.155 238.024 118.119C239.602 117.084 241.37 116.37 243.224 116.019L302.598 104.768C306.343 104.057 310.217 104.863 313.369 107.008C316.52 109.153 318.691 112.461 319.404 116.206C320.098 119.943 319.284 123.802 317.14 126.94C314.997 130.078 311.698 132.241 307.966 132.954Z",
    fill: "#7F29D6"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M307.966 132.954L248.604 144.252C246.75 144.606 244.845 144.591 242.997 144.208C241.149 143.825 239.394 143.081 237.833 142.02C236.273 140.959 234.936 139.601 233.901 138.023C232.865 136.445 232.15 134.679 231.797 132.825C231.442 130.971 231.456 129.065 231.839 127.217C232.221 125.368 232.964 123.613 234.025 122.052C235.087 120.491 236.446 119.155 238.024 118.119C239.602 117.084 241.37 116.37 243.224 116.019L302.598 104.768C306.343 104.057 310.217 104.863 313.369 107.008C316.52 109.153 318.691 112.461 319.404 116.206C320.098 119.943 319.284 123.802 317.14 126.94C314.997 130.078 311.698 132.241 307.966 132.954Z",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M258.811 131.126L259.093 132.638L251.85 134.068L250.01 124.41L257.042 123.062L257.323 124.574L252.061 125.571L252.541 128.079L257.229 127.2L257.511 128.676L252.823 129.555L253.327 132.228L258.811 131.126Z",
    fill: "black"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M267.427 131.044L264.872 128.594L264.497 128.676L262.317 129.098L262.856 131.911L261.063 132.251L259.223 122.582L263.196 121.832C265.739 121.34 267.556 122.348 267.966 124.481C268.121 125.137 268.061 125.826 267.795 126.447C267.529 127.067 267.072 127.586 266.489 127.926L269.314 130.68L267.427 131.044ZM263.442 123.367L261.344 123.766L262.082 127.61L264.18 127.211C265.751 126.918 266.43 126.039 266.208 124.867C265.985 123.695 265.024 123.062 263.442 123.367Z",
    fill: "black"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M277.528 129.122L275.008 126.672L274.645 126.754L272.465 127.165L272.993 129.989L271.199 130.329L269.359 120.66L273.344 119.91C275.876 119.418 277.704 120.426 278.114 122.559C278.265 123.215 278.204 123.903 277.938 124.523C277.673 125.142 277.217 125.661 276.637 126.004L279.462 128.759L277.528 129.122ZM273.543 121.445L271.446 121.844L272.184 125.688L274.282 125.289C275.852 124.996 276.532 124.117 276.298 122.945C276.063 121.773 275.126 121.176 273.543 121.445Z",
    fill: "black"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M279.698 123.707C279.452 122.678 279.52 121.599 279.893 120.608C280.266 119.618 280.927 118.762 281.791 118.151C282.655 117.54 283.683 117.202 284.741 117.18C285.799 117.158 286.839 117.454 287.728 118.028C288.616 118.603 289.312 119.431 289.726 120.405C290.14 121.379 290.252 122.455 290.049 123.493C289.846 124.532 289.336 125.486 288.586 126.232C287.835 126.978 286.879 127.483 285.839 127.68C285.174 127.843 284.482 127.869 283.807 127.755C283.132 127.641 282.487 127.391 281.912 127.019C281.336 126.646 280.843 126.161 280.463 125.592C280.082 125.022 279.822 124.381 279.698 123.707ZM288.3 122.067C288.181 121.377 287.858 120.738 287.373 120.233C286.889 119.727 286.264 119.378 285.58 119.23C284.896 119.082 284.183 119.141 283.532 119.401C282.882 119.661 282.324 120.108 281.93 120.687C281.536 121.266 281.323 121.949 281.32 122.649C281.316 123.349 281.522 124.035 281.911 124.617C282.299 125.2 282.853 125.653 283.5 125.919C284.148 126.185 284.86 126.251 285.546 126.11C285.999 126.038 286.432 125.874 286.819 125.628C287.206 125.383 287.539 125.061 287.798 124.683C288.057 124.304 288.236 123.877 288.324 123.428C288.413 122.978 288.409 122.515 288.312 122.067H288.3Z",
    fill: "black"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M299.257 124.984L296.749 122.535L296.374 122.617L294.194 123.027L294.733 125.851L292.94 126.191L291.1 116.487L295.073 115.737C297.616 115.245 299.433 116.253 299.843 118.386C299.998 119.043 299.938 119.732 299.672 120.352C299.406 120.972 298.949 121.491 298.366 121.832L301.191 124.586L299.257 124.984ZM295.272 117.308L293.174 117.706L293.912 121.55L296.01 121.152C297.581 120.859 298.261 119.98 298.026 118.808C297.792 117.636 296.854 117.003 295.272 117.308Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourZeroFour);
export default __webpack_public_path__ + "static/media/four-zero-four.206c4e19d42d571d0942c39d99b7db96.svg";
export { ForwardRef as ReactComponent };